/* eslint-disable quote-props */
/* eslint key-spacing: ["error"] */
/* eslint-disable max-len */
import Polyglot from "node-polyglot";

/**
 * Use Polyglot globally to set and retrieve text values / translations
 * and store setting in localStorage to persist
 *
 * Use the function lang.t('ID') in place of text throughout the app to
 * define string values, e.g. <div>{ lang.t('hello') }</div>
 *
 * See Polyglot documentation for further info including plurals and interpolated values
 */

/* Object Keys with underscores(_) indicate values which contain punctuation */

/* Define all text strings within the phrases object */
global.phrases = {
	// English
	en: {
		"(*)These options count towards call-offs": "(*)These options count towards call-offs",
		"# Invoices Paid": "# Invoices Paid",
		"+ Add position": "+ Add position",
		"$11M of included General Liability coverage for LEA, Officer, and Client":
			"$11M of included General Liability coverage for LEA, Officer, and Client",
		"*A minimum of two posting rules ares required":
			"*A minimum of two posting rules ares required",
		"*Rules that have the “keep open as FCFS” option checked cannot be used in a staggered set":
			"*Rules that have the “keep open as FCFS” option checked cannot be used in a staggered set",
		"*Rules with Manual Assignment types cannot be used in a staggered set":
			"*Rules with Manual Assignment types cannot be used in a staggered set",
		"*Only the first rule can post at a specific time, other rules have to be posted immediately":
			"*Only the first rule can post at a specific time, other rules have to be posted immediately",
		"*Run Time has to be at least 1 hour greater than signup period to allow time for assignments":
			"*Run Time has to be at least 1 hour greater than signup period to allow time for assignments",
		"run next rule": "run next rule",
		_hour: "/hour",
		"_to officer_": "to officer",
		"_for invoice #_": "for invoice #",
		"(Please explain why you are disputing this invoice)":
			"(Please explain why you are disputing this invoice)",
		"48 hours before job start_": "48 hours before job start.",
		"A contact with this email already exists": "A contact with this email already exists",
		"A contact with this email already exists_ Do you want to associate the client with this existing contact_":
			"A contact with this email already exists. Do you want to associate the client with this existing contact?",
		"A client must to be selected before creating a contact":
			"A client must to be selected before creating a contact",
		"A client have to be selected": "A client have to be selected",
		"A minimum of two posting rules ares required":
			"A minimum of two posting rules ares required",
		"A notification has already been sent to this officer within the last 24 hours_":
			"A notification has already been sent to this officer within the last 24 hours.",
		"A street address could not be found for the entered location_ Do you want to save this location anyway_":
			"A street address could not be found for the entered location. Do you want to save this location anyway?",
		"Ability to charge for various fees and route payment to appropriate parties":
			"Ability to charge for various fees and route payment to appropriate parties",
		"ACH Bank Transfer": "ACH Bank Transfer",
		"ACH or Credit Cards for payment of RKPay invoices_":
			"ACH or Credit Cards for payment of RKPay invoices.",
		Accept: "Accept",
		Accepted: "Accepted",
		"Access Denied": "Access Denied",
		"Access to InstantPay and Occupational Accident Insurance options for officers":
			"Access to InstantPay and Occupational Accident Insurance options for officers",
		Account: "Account",
		"Account Checklist": "Account Checklist",
		"Account Holder": "Account Holder",
		"Account Number": "Account Number",
		"Account Profile": "Account Profile",
		"Account Type": "Account Type",
		Action: "Action",
		Actions: "Actions",
		Active: "Active",
		"Active Clients Count": "Active Clients Count",
		"Active Directory ID": "Active Directory ID",
		"Active Jobs": "Active Jobs",
		"Active Projects": "Active Projects",
		Activities: "Activities",
		"Activities Timeline": "Activities Timeline",
		Activity: "Activity",
		"Actual Clock In": "Actual Clock In",
		"Actual Clock Out": "Actual Clock Out",
		"Actual Hours": "Actual Hours",
		"Activity Log": "Activity Log",
		Add: "Add",
		"Add attachment": "Add attachment",
		"Add rate": "Add rate",
		"Add a New Pay Code": "Add a New Pay Code",
		"Add a rule with a run time": "Add a rule with a run time",
		"Add account using a routing and account number":
			"Add account using a routing and account number",
		"Add Agency": "Add Agency",
		"Add as Agency Client": "Add as Agency Client",
		"Add base rate": "Add base rate",
		"Add Client": "Add Client",
		"Add Client Contact": "Add Client Contact",
		"Add Client Location": "Add Client Location",
		"Add Contact": "Add Contact",
		"Add Coordinator": "Add Coordinator",
		"Add Direct Deposit": "Add Direct Deposit",
		"Add emails below separated by a comma_": "Add emails below separated by a comma.",
		"Add Fee": "Add Fee",
		"Add Future Rate": "Add Future Rate",
		"Add Invoice": "Add Invoice",
		"Add Job": "Add Job",
		"Add Jobs": "Add Jobs",
		"Add Job to invoice": "Add Job to invoice",
		"Add Job to estimate": "Add Job to estimate",
		"Add Jurisdiction": "Add Jurisdiction",
		"Add Location": "Add Location",
		"Add Holiday": "Add Holiday",
		"Add holiday rate": "Add holiday rate",
		"Add New Excluded Agency": "Add New Excluded Agency",
		"Add New Required Agency": "Add New Required Agency",
		"Add Note": "Add Note",
		"Add Notes": "Add Notes",
		"Add Officer": "Add Officer",
		"Add Payment Method": "Add Payment Method",
		"Add Position": "Add Position",
		"Add position(s) and provide details": "Add position(s) and provide details",
		"Add Project": "Add Project",
		"Add reporting position": "Add reporting position",
		"Add restriction": "Add restriction",
		"Add Staff": "Add Staff",
		"Add Tag": "Add Tag",
		"Add comments": "Add comments",
		"Add it now_": "Add it now.",
		"Add Internal Note": "Add Internal Note",
		"Add jobs to your estimate": "Add jobs to your estimate",
		"Add jobs to your invoice": "Add jobs to your invoice",
		"Add to Estimate": "Add to Estimate",
		"Add to Invoice": "Add to Invoice",
		"Add Vehicle": "Add Vehicle",
		"Add vehicle fees and additional assets": "Add vehicle fees and additional assets",
		"Add new rule with this date range": "Add new rule with this date range",
		"Added Organization Deposit Account successfully":
			"Added Organization Deposit Account successfully",
		"Additional Agency Contact": "Additional Agency Contact",
		"Additional Assets": "Additional Assets",
		"Additional Comment": "Additional Comment",
		"Additional Details": "Additional Details",
		"Additional Fees": "Additional Fees",
		"Additional Items": "Additional Items",
		Address: "Address",
		"Address not found": "Address not found",
		Admin: "Admin",
		Administrator: "Administrator",
		"Admin Leave": "Admin Leave",
		After: "After",
		"After sign up period has expired, post job as first come first serve to whole department":
			"After sign up period has expired, post job as first come first serve to whole department",
		"After sign up period has expired, post job as First come first serve to whole department":
			"After sign up period has expired, post job as First come first serve to whole department",
		Agency: "Agency",
		"Agency Assignment Rules": "Agency Assignment Rules",
		"Agency Contact": "Agency Contact",
		"Agency Client": "Agency Client",
		"Agency Contact Phone": "Agency Contact Phone",
		"Agency Fees": "Agency Fees",
		"Agency Information": "Agency Information",
		"Agency Invoicing": "Agency Invoicing",
		"Agency Name": "Agency Name",
		"Agency name cannot be empty": "Agency name cannot be empty",
		"Agency Photo updated successfully": "Agency Photo updated successfully",
		"Agency Portal": "Agency Portal",
		"Agency Requirement": "Agency Requirement",
		"Agency Requirements": "Agency Requirements",
		"Agency Restrictions": "Agency Restrictions",
		"Agency Rules": "Agency Rules",
		"Agency Settings": "Agency Settings",
		"Agency Settings updated successfully": "Agency Settings updated successfully",
		"Agency Supervisor": "Agency Supervisor",
		"Agency users can not create jobs with locations pending approval":
			"Agency users can not create jobs with locations pending approval",
		"Agency restriction time must be selected": "Agency restriction time must be selected",
		"Agency name cannot be empty_": "Agency name cannot be empty.",
		"Agency Invoice IP": "Agency Invoice IP",
		"Alert Added successfully": "Alert Added successfully",
		Alerts: "Alerts",
		All: "All",
		"All Portals": "All Portals",
		"All (Agency Client)": "All (Agency Client)",
		"All (Tags)": "All (Tags)",
		"All coordination fees will be paid to the agency instead of being distributed to individual coordinator_":
			"All coordination fees will be paid to the agency instead of being distributed to individual coordinator_",
		"All officers are synced, no changes were made":
			"All officers are synced, no changes were made",
		"All officers from this group will be removed_":
			"All officers from this group will be removed.",
		"All projects and jobs related to this client will be deleted_":
			"All projects and jobs related to this client will be deleted.",
		"All upcoming jobs in each recurring series": "All upcoming jobs in each recurring series",
		"All upcoming jobs in this series": "All upcoming jobs in this series",
		"All jobs that have opted to exclude officer pay on the invoice must be grouped together_":
			"All jobs that have opted to exclude officer pay on the invoice must be grouped together.",
		"Allow job supervisors to override officer scheduling conflicts":
			"Allow job supervisors to override officer scheduling conflicts",
		"Allow jobs to stay posted when they have already started":
			"Allow jobs to stay posted when they have already started",
		"Allow users to apply for a job when there is a schedule conflict":
			"Allow users to apply for a job when there is a schedule conflict",
		"Allow officers to apply while the job is active":
			"Allow officers to apply while the job is active",
		"Allow supervisors to deny and approve jobs officers work_":
			"Allow supervisors to deny and approve jobs officers work.",
		"Allow personnel to override this rule": "Allow personnel to override this rule",
		"Allow or disallow officers to call off upcoming duties/schedules_":
			"Allow or disallow officers to call off upcoming duties/schedules.",
		"Allowed Locations": "Allowed Locations",
		"Already Posted Jobs": "Already Posted Jobs",
		"Already a member_": "Already a member?",
		"Already selected holiday rate date":
			"The date you have selected is already in use. Please select a different date.",
		Amended: "Amended",
		"Amendment Comment": "Amendment Comment",
		Amount: "Amount",
		"Amount Due": "Amount Due",
		"Amount must be equal to or less than the organization balance":
			"Amount must be equal to or less than the organization balance.",
		"Amount must be equal to or less than the payment balance":
			"Amount must be equal to or less than the payment balance.",
		"Amount must be greater than zero": "Amount must be greater than zero.",
		"Amount of Payment": "Amount of Payment",
		"An email has been sent to verify your email address_":
			"An email has been sent to verify your email address.",
		"An email has been sent to the officer": "An email has been sent to the officer",
		"An email has been sent to the supervisor": "An email has been sent to the supervisor",
		"An error occurred verifying the selected jurisdiction":
			"An error occurred verifying the selected jurisdiction",
		"An error occurred fetching estimates": "An error occurred fetching estimates",
		"An error occurred fetching invoices": "An error occurred fetching invoices",
		And: "And",
		Announcement: "Announcement",
		"Announcement not found": "Announcement not found",
		"Announcement successfully created": "Announcement successfully created",
		"Announcement deleted": "Announcement deleted",
		"Announcement preview requires a Title, Body, and Display Type to appear":
			"Announcement preview requires a Title, Body, and Display Type to appear",
		"Announcement successfully updated": "Announcement successfully updated",
		Announcements: "Announcements",
		"Any changes, including notes and job assignments, will be lost_":
			"Any changes, including notes and job assignments, will be lost.",
		"Any previously associated job items will be lost_":
			"Any previously associated job items will be lost.",
		"App Version": "App Version",
		Applicants: "Applicants",
		"Applicant Log": "Applicant Log",
		"Applicant Restrictions": "Applicant Restrictions",
		"Application Accepted successfully": "Application Accepted successfully",
		"Application Denied successfully": "Application Denied successfully",
		"Applied Payments": "Applied Payments",
		Apply: "Apply",
		"Apply assignment rule": "Apply assignment rule",
		"Apply Job Updates": "Apply Job Updates",
		"Apply Payment": "Apply Payment",
		"Apply Payments": "Apply Payments",
		"Apply PTAEO Code": "Apply PTAEO Code",
		"Apply or unapply payment(s) for an invoice or estimate":
			"Apply or unapply payment(s) for an invoice or estimate",
		"Apply the changes made to": "Apply the changes made to",
		"Apply officer minimum payrate": "Apply officer minimum payrate",
		"Applying job updates will overwrite all line items with data from the associated jobs_":
			"Applying job updates will overwrite all line items with data from the associated jobs.",
		Approval: "Approval",
		Approve: "Approve",
		"Approve Invoice": "Approve Invoice",
		"Approve Payment": "Approve Payment",
		"Approve Selected": "Approve Selected",
		"Approve or decline requests": "Approve or decline requests",
		"Approve payments easily": "Approve payments easily",
		Approved: "Approved",
		"Approved Amount": "Approved Amount",
		Archive: "Archive",
		"Archive Estimate": "Archive Estimate",
		ArchiveEstimateText_:
			"No further actions are needed for this estimate. Archiving will remove the estimate from your main list but keep it available for reference in the Estimates tab by using the Archived Only toggle.",
		Archived: "Archived",
		"Are certifications required for this position_":
			"Are certifications required for this position?",
		"Are pay codes mandatory_": "Are pay codes mandatory?",
		"Are officers required to receive permission from their supervisor prior to working an extra duty job_":
			"Are officers required to receive permission from their supervisor prior to working an extra duty job?",
		"Are pay codes mandatory?": "Are pay codes mandatory?",
		"Are there any types of venues that officers are not permitted to work_":
			"Are there any types of venues that officers are not permitted to work?",
		"Are there special instructions for this position_":
			"Are there special instructions for this position?",
		"Are you a Law Enforcement Agency_": "Are you a Law Enforcement Agency?",
		"Are you currently an active law enforcement officer_":
			"Are you currently an active law enforcement officer?",
		"Are you permitted to charge fees for assisting with the coordination of off-duty jobs_":
			"Are you permitted to charge fees for assisting with the coordination of off-duty jobs?",
		"Are you sure you want to change the business being invoiced_":
			"Are you sure you want to change the business being invoiced?",
		"Are you sure you want to continue_": "Are you sure you want to continue?",
		"Are you sure you want to delete organization":
			"Are you sure you want to delete organization",
		"Are you sure you want to delete project": "Are you sure you want to delete project",
		"Are you sure you want to delete these assigment rules_":
			"Are you sure you want to delete these assigment rules?",
		"Are you sure you want to delete these jobs_":
			"Are you sure you want to delete these jobs?",
		"Are you sure you want to delete this attachment_":
			"Are you sure you want to delete this attachment?",
		"Are you sure you want to delete this announcement_":
			"Are you sure you want to delete this announcement?",
		"Are you sure you want to delete this client_":
			"Are you sure you want to delete this client?",
		"Are you sure you want to delete this contact_":
			"Are you sure you want to delete this contact?",
		"Are you sure you want to delete this draft for":
			"Are you sure you want to delete this draft for",
		"Are you sure you want to delete this group_":
			"Are you sure you want to delete this group?",
		"Are you sure you want to delete this job_": "Are you sure you want to delete this job?",
		"Are you sure you want to delete this jurisdiction_":
			"Are you sure you want to delete this jurisdiction?",
		"Are you sure you want to delete this location_":
			"Are you sure you want to delete this location?",
		"Are you sure you want to delete this note_": "Are you sure you want to delete this note?",
		"Are you sure you want to delete this officer acknowledgement file_":
			"Are you sure you want to delete this officer acknowledgement file?",
		"Are you sure you want to delete this staff member_":
			"Are you sure you want to delete this staff member?",
		"Are you sure you want to delete this rule": "Are you sure you want to delete this rule?",
		"Are you sure you want to reassign_": "Are you sure you want to reassign?",
		"Are you sure you want to remove this job_": "Are you sure you want to remove this job?",
		"Are you sure you want to remove this payment method_":
			"Are you sure you want to remove this payment method?",
		"Are you sure you want to void": "Are you sure you want to void",
		"Are you sure you want to void this invoice_":
			"Are you sure you want to void this invoice?",
		"Are you sure you want to delete this vehicle number_ Past jobs will retain this vehicle number":
			"Are you sure you want to delete this vehicle number? Past jobs will retain this vehicle number",
		"Are you sure_": "Are you sure?",
		"Assets / Equipment": "Assets / Equipment",
		Assign: "Assign",
		"Assign Anyway": "Assign Anyway",
		"Assign Manually": "Assign Manually",
		"Assign Officer": "Assign Officer",
		"Assign Officers": "Assign Officers",
		"Assign Officers to Shift": "Assign Officers to Shift",
		"Assign this officer to the following days of the week in this series":
			"Assign this officer to the following days of the week in this series",
		Assigned: "Assigned",
		"Assigned Officer": "Assigned Officer",
		"Assigned Officers": "Assigned Officers",
		"Assigning this officer to this job will exceed their allowable number of hours per week_":
			"Assigning this officer to this job will exceed their allowable number of hours per week.",
		"Assigning this officer to this job will exceed their allowable number of hours_":
			"Assigning this officer to this job will exceed their allowable number of hours.",
		Assignment: "Assignment",
		"Assignment Audit": "Assignment Audit",
		Assignments: "Assignments",
		"Assignment Conflict": "Assignment Conflict",
		"Assignment Rule Name": "Assignment Rule Name",
		"Assignment Rule deleted successfully": "Assignment Rule deleted successfully",
		"Assignment Rules": "Assignment Rules",
		"Assignment Rules and Staggered Assignments": "Assignment Rules and Staggered Assignments",
		"Assignment rule created successfully": "Assignment rule created successfully",
		"Assignment rule updated successfully": "Assignment rule updated successfully",
		"Assignment Type": "Assignment Type",
		"Assignment Tie Breaker": "Assignment Tie Breaker",
		At: "at",
		"At least one city or county where jobs are allowed must be specified_":
			"At least one city or county where jobs are allowed must be specified.",
		"At least one venue type that officers are not permitted to work must be selected_":
			"At least one venue type that officers are not permitted to work must be selected.",
		"At least one option for officer replacements must be specified_":
			"At least one option for officer replacements must be specified.",
		Attachment: "Attachment",
		Attachments: "Attachments",
		"Attachment deleted successfully": "Attachment deleted successfully",
		"Attachments email sent": "Attachments email sent",
		Audience: "Audience",
		Audit: "Audit",
		"Auto-Assign: By Ascending Seniority": "Auto-Assign: By Ascending Seniority",
		"Auto-Assign: By Descending Seniority": "Auto-Assign: By Descending Seniority",
		"Auto-Assign: First-come, first-serve": "Auto-Assign: First-come, first-serve",
		"Auto-Assign: Number of hours": "Auto-Assign: Number of hours",
		"Auto-Assign: Number of jobs": "Auto-Assign: Number of jobs",
		"Auto-generate": "Auto-generate",
		"Automatic Clock-Out": "Automatic Clock-Out",
		"Automatically Opt-In All Officers to Insurance":
			"Automatically Opt-In All Officers to Insurance",
		"Automatically post and/or assign officers_": "Automatically post and/or assign officers.",
		"Automated reminders regarding invoices that need to be created, sent out and paid for":
			"Automated reminders regarding invoices that need to be created, sent out and paid for",
		"Automated reminders to create, send or pay invoices":
			"Automated reminders to create, send or pay invoices",
		"Avg Officer Rate": "Avg. Officer Rate",
		Attention: "Attention *",
		"Attention Exclude Pay TextBox":
			"Any pay related to the officer/personnel working this job is not included in this invoice. If you would like to pay for all job pay in one electronic transaction, please get in touch with your department contact.",
		"Avg Rate": "Avg. Rate",
		"Available Funds": "Available Funds",
		"Actual Clock In / Clock Out Time": "Actual Clock In / Clock Out Time",
		AddToEstimateDisableButtonMessage:
			"Jobs selected are not the same invoicing type or already invoiced, please change selection to use this option",
		Back: "Back",
		"Back Image": "Back Image",
		"Back to Job": "Back to Job",
		"Back to Login": "Back to Login",
		"Back to clients": "Back to clients",
		"Back to list": "Back to list",
		"Back to locations list": "Back to locations list",
		Balance: "Balance",
		"Balance Due": "Balance Due",
		"Bank Account (Last 4 digits)": "Bank Account (Last 4 digits)",
		"Bank Account Info": "Bank Account Info",
		"Bank Account verified successfully": "Bank Account verified successfully",
		"Basic details for this job": "Basic details for this job",
		"Based on first-come first-serve rule": "Based on first-come first-serve rule",
		"Base Rates": "Base Rates",
		"Base Rate rules Tooltip":
			"Base Rate rules apply at all times by default, unless superseded by Holiday Rates",
		"Be sure to include any specific instructions of duties_":
			"Be sure to include any specific instructions of duties.",
		"Benefits of electronic invoicing through RollKall":
			"You will be missing out on these benefits of invoicing online through the RollKall Platform",
		"Bi-Annually": "Bi-Annually",
		"Billing Address": "Billing Address",
		"Billing address is required": "Billing address is required",
		"Billing Contact": "Billing Contact",
		"Billing Street Address": "Billing Street Address",
		"Billing contact is required": "Billing contact is required",
		"Billing contact email format is invalid": "Billing contact email format is invalid",
		"Billing contact email is required": "Billing contact email is required",
		BulkV2Invoiceserror: "Cannot send V2 invoices in bulk.",
		Block: "Block",
		Blocking: "Blocking",
		Body: "Body",
		Bold: "Bold",
		"Bulk Assignment": "Bulk Assignment",
		"Bulk Invoice Preview": "Bulk Invoice Preview",
		"Bulk Send Invoices Paid Message_":
			"Any Invoices with a $0 Balance will be moved to Paid, and the client will receive a separate receipt email.",
		"Business Address": "Business Address",
		"Department Address": "Department Address",
		"Department fees": "Department fees",
		By: "By",
		"By editing this URL the previous version will no longer work, Are you sure you want to proceed_":
			"By editing this URL the previous version will no longer work, Are you sure you want to proceed?",
		"By enabling this toggle, you consent to receive SMS messages (including text messages) from RollKall, notwithstanding any current or prior election to opt in or opt out of receiving SMS messages, at the specific number(s) you have provided to us, or numbers we can reasonably associate with your account, with information or questions related to your account_":
			"By enabling this toggle, you consent to receive SMS messages (including text messages) from RollKall, notwithstanding any current or prior election to opt in or opt out of receiving SMS messages, at the specific number(s) you have provided to us, or numbers we can reasonably associate with your account, with information or questions related to your account.",
		"By removing this job, the following line item will be deleted_":
			"By removing this job, the following line item will be deleted:",
		"By removing this job, the following line items will be deleted_":
			"By removing this job, the following line items will be deleted:",
		"By Seniority (Ascending)": "By Seniority (Ascending)",
		"By Seniority (Descending)": "By Seniority (Descending)",
		"By hours": "By hours",
		"By number of jobs": "By number of jobs",
		"Calendar View": "Calendar View",
		"Call Offs": "Call Offs",
		"Call Off Range": "Call Off Range",
		"Call-off Type": "Call-off Type",
		"Call-Off Date": "Call-Off Date",
		"Call-off Date": "Call-off Date",
		"Call offs are no longer allowed": "Call offs are no longer allowed",
		"Called Off": "Called Off",
		Cancel: "Cancel",
		"Cancellation lockout_": "Cancellation lockout",
		"Cancelled due to Inclement Weather": "Cancelled due to Inclement Weather",
		"Cannot assign more than 5 tags to a job": "Cannot assign more than 5 tags to a job",
		Card: "Card",
		"Card Holder Full Name": "Card Holder Full Name",
		"Card Number": "Card Number",
		Carrier: "Carrier",
		Cash: "Cash",
		Certifications: "Certifications",
		"Certifications Required": "Certifications Required",
		"Account Security Change Email Text": "Email",
		Change: "Change",
		"Change Image": "Change Image",
		"Change Password": "Change Password",
		"Change Recipient": "Change Recipient",
		"Change agency name, profile picture, billing contact, email, and payment details_":
			"Change agency name, profile picture, billing contact, email, and payment details.",
		"Change to Pending Review": "Change to Pending Review",
		"Changed By": "Changed By",
		"Changes In": "Changes In",
		"Changing Client": "Changing Client",
		"Changing reporting tier may affect billing_":
			"Changing the reporting tier may affect billing.  It will also delete all current reports from this Organization.  Are you sure you would like to continue?",
		Check: "Check",
		"Check this box if you would like to use a pay code when creating a job_":
			"Check this box if you would like to use a pay code when creating a job.",
		"Check this box if you would like to review and approve all invoices prior to them being sent to the client_":
			"Check this box if you would like to review and approve all invoices prior to them being sent to the client.",
		Checklist: "Checklist",
		"Checking yes means you would like to send this job as an estimate to the client contact_":
			"Checking yes means you would like to send this job as an estimate to the client contact.",
		"Choose penalty type_": "Choose penalty type",
		City: "City",
		Clear: "Clear",
		"Clear All": "Clear All",
		"Click to answer": "Click to answer",
		Client: "Client",
		"Client Cancelled": "Client Cancelled",
		"Client Contact": "Client Contact",
		"Client Contact Phone": "Client Contact Phone",
		"Client Contacts": "Client Contacts",
		"Client Details": "Client Details",
		"Client First Start Date": "Client First Start Date",
		"Client is authorized to use department vehicles":
			"Client is authorized to use department vehicles",
		"Client Name": "Client Name",
		"Client not authorized to use department vehicles":
			"Client not authorized to use department vehicles",
		"Client Payment Summary": "Client Payment Summary",
		"Client Portal": "Client Portal",
		"Client Profile": "Client Profile",
		"Client Reference": "Client Reference",
		"Client Sign-up URL_": "Client Sign-up URL:",
		"Client Supervisor": "Client Supervisor",
		"Client deleted successfully": "Client deleted successfully",
		"Client rates successfully updated": "Client rates successfully updated",
		"Client successfully": "Client successfully",
		"Client successfully deleted": "Client successfully deleted",
		Clients: "Clients",
		"Clients will no longer be able to pay online if you apply a manual payment to this invoice_":
			"Clients will no longer be able to pay online if you apply a manual payment to this invoice.",
		"Clock In": "Clock-In",
		"Clock in Vehicle Mileage": "Clock in Vehicle Mileage",
		"Clock-In": "Clock-In",
		"Clock In/Out": "Clock-In/Out",
		"Clock Out": "Clock-Out",
		"Clock out Vehicle Mileage": "Clock out Vehicle Mileage",
		"Clock-Out": "Clock-Out",
		"Clocked In": "Clocked In",
		"Clocked Out": "Clocked Out",
		"Timecard Clock In": "Clock In",
		"Timecard Clock Out": "Clock Out",
		Close: "Close",
		"Close Preview": "Close Preview",
		"Collapse All": "Collapse All",
		Comments: "Comments",
		Company: "Company",
		"Company Name": "Company Name",
		Completed: "Completed",
		"Completed Call-off Date": "Completed Call-off Date",
		"Completed Jobs": "Completed Jobs",
		"Comprehensive invoice reporting for compliance and auditing":
			"Comprehensive invoice reporting for compliance and auditing",
		"Comprehensive financial reporting for compliance and auditing":
			"Comprehensive financial reporting for compliance and auditing",
		"Connected Invoice": "Connected Invoice",
		"Connected Estimate": "Connected Estimate",
		Configure: "Configure",
		"Configure Client Charges": "Configure Client Charges",
		"Configure Platform Charges": "Configure Platform Charges",
		"Configure Reports": "Configure Reports",
		Confirm: "Confirm",
		"Confirm Changes": "Confirm Changes",
		"Confirm Account Number": "Confirm Account Number",
		"Confirm Job Removal": "Confirm Job Removal",
		"Confirm Password": "Confirm Password",
		"Confirm Void & Refund": "Confirm Void & Refund",
		"Confirmation email sent_": "Confirmation email sent.",
		Conflict: "Conflict",
		"Consolidated W9/1099 documentation and 1099-K distribution at year-end":
			"Consolidated W9/1099 documentation and 1099-K distribution at year-end",
		Contact: "Contact",
		"Contact Info": "Contact Info",
		"Contact Details": "Contact Details",
		"Contact successfully created": "Contact successfully created",
		"Contact successfully deleted": "Contact successfully deleted",
		"Contact successfully updated": "Contact successfully updated",
		"Contact successfully merged": "Contact successfully merged",
		"Contact to Invite": "Contact to Invite",
		"Contact your agency_s administrator to make necessary assets available":
			"Contact your agency's administrator to make necessary assets available",
		Contacts: "Contacts",
		Continue: "Continue",
		"Control how jobs are posted and assigned_": "Control how jobs are posted and assigned.",
		"Convert an existing estimate into an invoice":
			"Convert an existing estimate into an invoice",
		"Convert to Invoice": "Convert to Invoice",
		"Converting an estimate to an invoice cannot be undone_":
			"Converting an estimate to an invoice cannot be undone.",
		Coordinates: "Coordinates",
		Coordination: "Coordination",
		"Coordination Fee": "Coordination Fee",
		"Coordination Fee updated successfully": "Coordination Fee updated successfully",
		"Coordination fees": "Coordination fees",
		"Coordination Fees": "Coordination Fees",
		"Coordination fee will be added to the hourly officer rate_":
			"Coordination fee will be added to the hourly officer rate.",
		Coordinator: "Coordinator",
		Coordinators: "Coordinators",
		"Coordinators can override on-duty scheduling conflicts":
			"Coordinators can override on-duty scheduling conflicts",
		"Coordinator fees": "Coordinator fees",
		"Coordinator Fees": "Coordinator Fees",
		"Coordinator Jobs": "Coordinator Jobs",
		"Coordinator Portal": "Coordinator Portal",
		"Coordinator charges to client": "Coordinator charges to client",
		"Coordinator created successfully": "Coordinator created successfully",
		"Coordinator details saved successfully": "Coordinator details saved successfully",
		"Coordinator/Dept Details": "Coordinator/Dept. Details",
		Copied: "Copied",
		"Copy to clipboard": "Copy to clipboard",
		County: "County",
		"Count call offs within the given number of days_":
			"Count call offs within the given number of days",
		Create: "Create",
		"Create Estimate": "Create Estimate",
		"Create Invoice": "Create Invoice",
		"Create New Invoice": "Create New Invoice",
		"Create New Estimate": "Create New Estimate",
		"Create New Rule": "Create New Rule",
		"Create New Assignment Rule": "Create New Assignment Rule",
		"Create New Posting Rule": "Create New Posting Rule",
		"Create New Staggered Rule": "Create New Staggered Rule",
		"Create Staggered Posting Rule": "Create Staggered Posting Rule",
		"Create/Edit Staggered Rule": "Create/Edit Staggered Rule",
		"Create New Rule with Date Range": "Create New Rule with Date Range",
		"Create Shift": "Create Shift",
		Created: "Created",
		"Created By": "Created By",
		"Created Date": "Created Date",
		"Created Invoice Date": "Created Invoice Date",
		Creating: "Creating",
		"Credit Card": "Credit Card",
		Current: "Current",
		"Current Hours": "Current Hours",
		"Current Miles": "Current Miles",
		"Current Rate": "Current Rate",
		"Current Value": "Current Value",
		"Custom Date Range": "Custom Date Range",
		"Custom Invoice Disclaimer": "Custom Invoice Disclaimer",
		"Customize officer penalties_": "Customize officer penalties",
		"Change to Pending Client Review": "Change to Pending Client Review",
		Daily: "Daily",
		"Daily:": "Daily:",
		Dashboard: "Dashboard",
		Date: "Date",
		Date_: "Date:",
		"Date Last Used": "Date Last Used",
		Dates: "Dates",
		"Date Created": "Date Created",
		"Date Issued": "Date Issued",
		"Date Range": "Date Range",
		"Date of Birth (MM/DD/YYYY)": "Date of Birth (MM/DD/YYYY)",
		days: "days",
		Days: "Days",
		"days, starting": "days, starting",
		"Deactivated per users request": "Deactivated per users request",
		Decline: "Decline",
		Default: "Default",
		Defaults: "Defaults",
		"Default card updated successfully": "Default card updated successfully",
		"Define invoice changes to apply after a job is worked":
			"Define invoice changes to apply after a job is worked",
		Delay: "Delay",
		"Delay Viewing": "Delay Viewing",
		Delete: "Delete",
		"Delete Agency Restriction": "Delete Agency Restriction",
		"Delete Attachment": "Delete Attachment",
		"Delete Announcement": "Delete Announcement",
		"Delete Asset": "Delete Asset",
		"Delete Assignment Rule": "Delete Assignment Rule",
		"Delete Client": "Delete Client",
		"Delete Contact": "Delete Contact",
		"Delete Document Confirmation": "Delete Document Confirmation",
		"Delete Draft": "Delete Draft",
		"Delete Fee": "Delete Fee",
		"Delete File": "Delete File",
		"Delete Group": "Delete Group",
		"Delete Job": "Delete Job",
		"Delete Jobs": "Delete Jobs",
		"Delete Job Position": "Delete Job Position",
		"Delete Jurisdiction": "Delete Jurisdiction",
		"Delete Location": "Delete Location",
		"Delete Note": "Delete Note",
		"Delete Organization": "Delete Organization",
		"Delete Officer Acknowledgement File": "Delete Officer Acknowledgement File",
		"Delete Project": "Delete Project",
		"Delete Reasons": "Delete Reasons",
		"Delete Report": "Delete Report",
		"Delete Rule": "Delete Rule",
		"Delete Shift": "Delete Shift",
		"Delete Selected": "Delete Selected",
		"Delete Staff Member": "Delete Staff Member",
		"Delete Tag": "Delete Tag",
		"Delete Vehicle": "Delete Vehicle",
		"Delete Zone": "Delete Zone",
		Deleted: "Deleted",
		"Deleting report will remove visibility for all users in the Organization_":
			"Deleting report will remove visibility for all users in the Organization. Are you sure you want to proceed?",
		Denied: "Denied",
		"Denied Location with Officers": "Denied Location with Officers",
		Deny: "Deny",
		"Deny Selected": "Deny Selected",
		Department: "Department",
		"Department Cancelled": "Department Cancelled",
		"Department Info": "Department Info",
		"Department Reference": "Department Reference",
		"Department Name for Display": "Department Name for Display",
		"Deposit Date": "Deposit Date",
		"Deposit History": "Deposit History",
		"Deposit Start Date": "Deposit Start Date",
		"Deposit End Date": "Deposit End Date",
		"Deposit account set successfully for organization fee":
			"Deposit account set successfully for organization fee",
		"Describe what the officer will be doing_": "Describe what the officer will be doing.",
		Description: "Description",
		"Description can not be empty": "Description can not be empty.",
		Details: "Details",
		Device: "Device",
		"Default Invoicing": "Default Invoicing",
		Diagnostics: "Diagnostics",
		"Direct Deposit": "Direct Deposit",
		"Direct Deposit Account": "Direct Deposit Account",
		"Direct Deposit Account created successfully":
			"Direct Deposit Account created successfully",
		"Direct Deposit Account updated successfully":
			"Direct Deposit Account updated successfully",
		"Direct deposit information to collect department fees or funds_":
			"Direct deposit information to collect department fees or funds.",
		"Direct Deposit Information": "Direct Deposit Information",
		"Disable Instant Pay": "Disable Instant Pay",
		"Discard Changes": "Discard Changes",
		Disclaimer: "Disclaimer",
		Dismiss: "Dismiss",
		"Display From": "Display From",
		"Display Type": "Display Type",
		"Display Until": "Display Until",
		"Display on job listing": "Display on job listing",
		Dispute: "Dispute",
		Disputed: "Disputed",
		"Invoice Dispute(s)": "Invoice Dispute(s)",
		"Dispute Details": "Dispute Details",
		"Dispute Invoice": "Dispute Invoice",
		"Dispute Submitted": "Dispute Submitted",
		"Dispute an Invoice": "Dispute an Invoice",
		"Hours Incorrect": "Hours Incorrect",
		"Billing Details Incorrect": "Billing Details Incorrect",
		"Rate Incorrect": "Rate Incorrect",
		"Job Not Worked": "Job Not Worked",
		"Fees And Taxes Incorrect": "Fees And Taxes Incorrect",
		"Already Paid For": "Already Paid For",
		"Officer Misc Fees": "Officer Misc Fees",
		"Officer Misc Fees Incorrect": "Officer Misc Fees Incorrect",
		"Disputed By": "Disputed By",
		"Do Not Hire": "Do Not Hire",
		"Do not rehire": "Do not rehire",
		"Do you limit the number of hours your officers can work_":
			"Do you limit the number of hours your officers can work?",
		"Do you need more than one officer for this position_":
			"Do you need more than one officer for this position?",
		"Do you require that a location receive approval prior to your officers working at the location_":
			"Do you require that a location receive approval prior to your officers working at the location?",
		"Do you utilize Zones in your agency?": "Do you utilize Zones in your agency?",
		"Do you want to assign only to jobs that qualify_":
			"Do you want to assign only to jobs that qualify?",
		"Do you want to assign the officer to the job anyway_":
			"Do you want to assign the officer to the job anyway?",
		"Do you want to assign the officer to the job series anyway_":
			"Do you want to assign the officer to the job series anyway?",
		"Do you want to associate the client with this existing contact_":
			"Do you want to associate the client with this existing contact?",
		"Do you want to associate the client with this existing contact?":
			"Do you want to associate the client with this existing contact?",
		"Do you want to continue invoicing these jobs_":
			"Do you want to continue invoicing these jobs?",
		"Do you want to migrate existing officer(s) to another group or remove all the officer(s) from the list_":
			"Do you want to migrate existing officer(s) to another group or remove all the officer(s) from the list?",
		"Do you want to remove them, or keep them_": "Do you want to remove them, or keep them?",
		"Do you want to save these changes_": "Do you want to save these changes?",
		"Do you want to unassign only this instance, or all upcoming instances of this series_":
			"Do you want to unassign only this instance, or all upcoming instances of this series?",
		Document: "Document",
		Documents: "Documents",
		"Does this position require a minimum rank_": "Does this position require a minimum rank?",
		"Does this position require a maximum rank_": "Does this position require a maximum rank?",
		"Does this position have rank restrictions_": "Does this position have rank restrictions?",
		Done: "Done",
		"Don_t see your department_": "Don't see your department?",
		Download: "Download",
		"Download All": "Download All",
		"Download PDF": "Download PDF",
		"Dress Type": "Dress Type",
		Due: "Due",
		"Due Date": "Due Date",
		"Due on Receipt": "Due on Receipt",
		Duplicate: "Duplicate",
		"Duplicate Job": "Duplicate Job",
		"ELVN / Tax ID": "ELVN / Tax ID",
		"Default Manual Reconcilliation": "Default Manual Reconcilliation",
		EMail: "E-Mail",
		"E-mail Invoice": "E-mail Invoice",
		"E-mail Estimate": "E-mail Estimate",
		Email: "Email",
		"Each type of vehicle already has a fee defined":
			"Each type of vehicle already has a fee defined",
		Earlier: "Earlier",
		"Early Clock-Out": "Early Clock-Out",
		Edit: "Edit",
		"Edit Address": "Edit Address",
		"Edit Client": "Edit Client",
		"Edit Client Location": "Edit Client Location",
		"Edit Contact": "Edit Contact",
		"Edit Direct Deposit": "Edit Direct Deposit",
		"Edit Image": "Edit Image",
		"Edit Invoice": "Edit Invoice",
		"Edit Invoice For": "Edit Invoice For",
		"Edit Job": "Edit Job",
		"Edit Job Series": "Edit Job Series",
		"Edit Jurisdiction": "Edit Jurisdiction",
		"Edit Logo": "Edit Logo",
		"Edit Project": "Edit Project",
		"Edit Recipients": "Edit Recipient(s)",
		"Email Address": "Email Address",
		"Edit Shift": "Edit Shift",
		"Edit Sign-up URL": "Edit Sign-up URL",
		"Edit Vehicle": "Edit Vehicle",
		"Edit Timecard": "Edit Timecard",
		"Effective Date": "Effective Date",
		"e_g_ Net 15 for all invoices":
			"e.g. Net 15 for all invoices.\u000AWhen paying an invoice, please remit payment to:\u000A(address)",
		"Email is invalid": "Email is invalid",
		"Email required": "Email required",
		"Emergency Contact": "Emergency Contact",
		Emphasis: "Emphasis",
		"Enable push notifications": "Enable push notifications",
		"Enable push notifications for this device": "Enable push notifications for this device",
		End: "End",
		"End Date": "End Date",
		"End Date & Time": "End Date & Time",
		"End Period": "End Period",
		"End Time": "End Time",
		"End date must be greater than Start date": "End date must be greater than Start date",
		Ends: "Ends",
		"Enforce hourly restrictions of department": "Enforce hourly restrictions of department",
		"Enter User ID": "Enter User ID",
		"Enforce officer penalties": "Enforce officer penalties",
		"Enter Email of Agency/Coordinator User": "Enter Email of Agency/Coordinator User",
		"Enter Non-RollKall officer_s name": "Enter Non-RollKall officer's name",
		"Enter description": "Enter description",
		"Enter short code": "Enter short code",
		"Enter your contact information": "Enter your contact information",
		"Enter your personal information": "Enter your personal information",
		Equipment: "Equipment",
		"Equipment Fees": "Equipment Fees",
		"Equipment for Event has not arrived": "Equipment for Event has not arrived",
		"Equipment not received": "Equipment not received",
		Error: "Error",
		"Error trying to set deposit account for fee":
			"Error trying to set deposit account for fee",
		"Error loading Organization Deposit Accounts":
			"Error loading Organization Deposit Accounts",
		"Error loading invoice attachments": "Error loading invoice attachments",
		"Error adding Organization Deposit Account": "Error adding Organization Deposit Account",
		"Error Getting Associated Invoices": "Error Getting Associated Invoices",
		"Error Getting Estimate Actions": "Error Getting Estimate Actions",
		"Error Getting Organization Staff": "Error Getting Organization Staff",
		"Error Getting Organization Agency Settings Timezones":
			"Error Getting Organization Agency Settings Timezones",
		"Error Getting Organization Balance": "Error Getting Organization Balance",
		"Error getting estimate refundable amount": "Error getting estimate refundable amount",
		"Error inviting client": "Error inviting client",
		"Error initiating refund": "Error initiating refund",
		"Error Uploading Agency Photo": "Error Uploading Agency Photo",
		"Error adding Note": "Error adding Note",
		"Error adding Payment Method": "Error adding Payment Method",
		"Error adding to invoice": "Error adding to invoice",
		"Error adding to estimate": "Error adding to estimate",
		"Error applying payment": "Error applying payment",
		"Error assigning Officer": "Error assigning Officer",
		"Error archiving estimate": "Error archiving estimate",
		"Error converting estimate": "Error converting estimate",
		"Error creating Assignment Rule": "Error creating Assignment Rule",
		"Error creating Jurisdiction": "Error creating Jurisdiction",
		"Error creating Project": "Error creating Project",
		"Error creating account": "Error creating account",
		"Error creating client": "Error creating client",
		"Error creating contact": "Error creating contact",
		"Error creating location": "Error creating location",
		"Error creating the Call Offs Penalty Rules": "Error creating the Call Offs Penalty Rules",
		"Error creating new paycode": "Error creating new paycode",
		"Error creating staggered Rule": "Error creating staggered Rule",
		"Error creating invoice rules": "Error creating invoice rules",
		"Error deleting": "Error deleting",
		"Error creating shift": "Error creating shift",
		"Error creating vehicle": "Error creating vehicle",
		"Error updating vehicle": "Error updating vehicle",
		"Error deleting vehicle": "Error deleting vehicle",
		"Error loading vehicles": "Error loading vehicles",
		"Error loading Coordinators": "Error loading Coordinators",
		"Error deleting Announcements": "Error deleting Announcements",
		"Error deleting Assignment Rule": "Error deleting Assignment Rule",
		"Error deleting invoice rules": "Error deleting invoice rules",
		"Error posting invoice rules": "Error posting invoice rules",
		"Error deleting Job": "Error deleting Job",
		"Error deleting Jobs": "Error deleting Jobs",
		"Error deleting Note": "Error deleting Note",
		"Error deleting Payment Method": "Error deleting Payment Method",
		"Error deleting shift": "Error deleting shift",
		"Error deleting staff member": "Error deleting staff member",
		"Error deleting client": "Error deleting client",
		"Error deleting contact": "Error deleting contact",
		"Error deleting document": "Error deleting document",
		"Error deleting group": "Error deleting group",
		"Error deleting jurisdiction": "Error deleting jurisdiction",
		"Error deleting location": "Error deleting location",
		"Error deleting organization": "Error deleting organization",
		"Error deleting paycode": "Error deleting paycode",
		"Error deleting project": "Error deleting project",
		"Error deleting Staggered Rule": "Error deleting Staggered Rule",
		"Error downloading attachments": "Error downloading attachments",
		"Error fetching Hubspot contacts": "Error fetching Hubspot contacts",
		"Error finalizing estimate": "Error finalizing estimate",
		"Error finalizing invoice": "Error finalizing invoice",
		"Error importing PTAEO codes": "Error importing PTAEO codes",
		"Error generating invoice": "Error generating invoice",
		"Error generating report": "Error generating report",
		"Error generating report file": "Error generating report file",
		"Error getting Agency Restrictions": "Error getting Agency Restrictions",
		"Error getting Available Funds": "Error getting Available Funds",
		"Error getting balance": "Error getting balance",
		"Error getting Billing Details": "Error getting Billing Details",
		"Error getting Client Details": "Error getting Client Details",
		"Error getting Estimate Invoiceable": "Error getting Estimate Invoiceable",
		"Error getting invoice internal notes_": "Error getting invoice internal notes.",
		"Error getting Job Invoices": "Error getting Job Invoices",
		"Error getting Job Activity Timeline": "Error getting Job Activity Timeline",
		"Error getting Job Approvals Counts": "Error getting Job Approvals Counts",
		"Error getting Job Estimate": "Error getting Job Estimate",
		"Error getting Jurisdiction Agency Rules": "Error getting Jurisdiction Agency Rules",
		"Error getting Jurisdiction Fees": "Error getting Jurisdiction Fees",
		"Error getting Jurisdiction Officer Rules": "Error getting Jurisdiction Officer Rules",
		"Error getting Jurisdiction Payment Rules": "Error getting Jurisdiction Payment Rules",
		"Error getting LEA Locations": "Error getting LEA Locations",
		"Error getting LEA Locations Counts": "Error getting LEA Locations Counts",
		"Error getting Location Notes": "Error getting Location Notes",
		"Error getting Officer Groups": "Error getting Officer Groups",
		"Error getting Officers": "Error getting Officers",
		"Error getting shifts": "Error getting shifts",
		"Error getting Tax Exemption Counts": "Error getting Tax Exemption Counts",
		"Error getting Tax Exemption Requests": "Error getting Tax Exemption Requests",
		"Error getting the Call Offs Penalty Rules": "Error getting the Call Offs Penalty Rules",
		"Error getting locations": "Error getting locations",
		"Error getting notes": "Error getting notes",
		"Error getting payment history": "Error getting payment history",
		"Error getting the current status of the payment":
			"Error getting the current status of the payment",
		"Error getting token": "Error getting token",
		"Error getting vehicle invoicing agency rules":
			"Error getting vehicle invoicing agency rules",
		"Error loading Instant Pay reasons, Please try again":
			"Error loading Instant Pay reasons, Please try again",
		"Error loading Activity Log": "Error loading Activity Log",
		"Error loading Agencies": "Error loading Agencies",
		"Error loading applicants history": "Error loading applicants history",
		"Error loading Announcement details": "Error loading Announcement details",
		"Error loading Announcements": "Error loading Announcements",
		"Error loading Applicants": "Error loading Applicants",
		"Error loading Assigned Officers": "Error loading Assigned Officers",
		"Error loading Assignment Rule": "Error loading Assignment Rule",
		"Error loading Assignment Rules": "Error loading Assignment Rules",
		"Error loading Client Projects": "Error loading Client Projects",
		"Error loading Dress Types": "Error loading Dress Types",
		"Error loading Grouped Officers": "Error loading Grouped Officers",
		"Error loading Groups": "Error loading Groups",
		"Error loading Job": "Error loading job",
		"Error loading jobs": "Error loading jobs",
		"Error loading Job Counts": "Error loading Job Counts",
		"Error loading Job Points": "Error loading Job Points",
		"Error loading Job Types": "Error loading Job Types",
		"Error loading Jobs": "Error loading jobs",
		"Error loading job drafts": "Error loading job drafts",
		"Error loading Job List": "Error loading Job List",
		"Error loading Jurisdiction Details": "Error loading Jurisdiction Details",
		"Error loading location types": "Error loading location types",
		"Error loading Locations": "Error loading Locations",
		"Error loading Officer Counts": "Error loading Officer Counts",
		"Error loading Payment Counts": "Error loading Payment Counts",
		"Error loading Payment List": "Error loading Payment List",
		"Error loading Payment Methods": "Error loading Payment Methods",
		"Error loading receipts": "Error loading receipts",
		"Error loading estimates": "Error loading estimates",
		"Error loading Time Zones": "Error loading Time Zones",
		"Error loading US States": "Error loading US States",
		"Error loading Users": "Error loading Users",
		"Error loading Vehicle Types": "Error loading Vehicle Types",
		"Error loading agency contacts": "Error loading agency contacts",
		"Error loading call offs": "Error loading call offs",
		"Error loading client contacts": "Error loading client contacts",
		"Error loading client coordinators": "Error loading client coordinators",
		"Error loading client information": "Error loading client information",
		"Error loading clients": "Error loading clients",
		"Error loading contact information": "Error loading contact information",
		"Error loading contacts": "Error loading contacts",
		"Error loading google map location": "Error loading google map location",
		"Error loading invoice details": "Error loading invoice details",
		"Error loading invoices": "Error loading invoices",
		"Error loading invoice rules": "Error loading invoice rules",
		"Error loading invoice status history": "Error loading invoice status history",
		"Error loading job history": "Error loading job history",
		"Error loading job tags": "Error loading job tags",
		"Error loading jurisdiction history": "Error loading jurisdiction history",
		"Error loading jurisdictions": "Error loading jurisdictions",
		"Error loading location details": "Error loading location details",
		"Error loading notes": "Error loading notes",
		"Error loading notification settings": "Error loading notification settings",
		"Error loading notifications": "Error loading notifications",
		"Error loading officer": "Error loading officer",
		"Error loading officer details": "Error loading officer details",
		"Error loading officer ranks": "Error loading officer ranks",
		"Error loading officers": "Error loading officers",
		"Error loading organizations": "Error loading organizations",
		"Error loading payment history": "Error loading payment history",
		"Error loading paycodes": "Error loading paycodes",
		"Error loading project": "Error loading project",
		"Error loading project list": "Error loading project list",
		"Error loading projects": "Error loading projects",
		"Error loading PTAEO codes": "Error loading PTAEO codes",
		"Error loading staff members": "Error loading staff members",
		"Error loading staggered Rule": "Error loading staggered Rule",
		"Error loading staggered Rules": "Error loading staggered Rules",
		"Error loading time card notes.": "Error loading time card notes.",
		"Error loading Location Zones": "Error loading Location Zones",
		"Error loading Scheduling Options": "Error loading Scheduling Options",
		"Error loading invoice totals": "Error loading invoice totals",
		"Error moving the Jurisdiction": "Error moving the Jurisdiction",
		"Error posting Job": "Error posting Job",
		"Error posting Jobs": "Error posting Jobs",
		"Error resending estimate": "Error resending estimate",
		"Error resetting password": "Error resetting password",
		"Error restoring Job": "Error restoring Job",
		"Error restoring call off": "Error restoring call off",
		"Error retrieving billing contact details": "Error retrieving billing contact details",
		"Error retrieving certifications": "Error retrieving certifications",
		"Error retrieving client details": "Error retrieving client details",
		"Error retrieving line items": "Error retrieving line items",
		"Error retrieving officer certifications": "Error retrieving officer certifications",
		"Error retrieving shift details": "Error retrieving shift details",
		"Error retrieving refunded amount": "Error retrieving refunded amount",
		"Error retrieving invoices summary": "Error retrieving invoices summary",
		"Error saving Jurisdiction Agency Rules": "Error saving Jurisdiction Agency Rules",
		"Error saving Jurisdiction Officer Rules": "Error saving Jurisdiction Officer Rules",
		"Error saving Jurisdiction Payment Rules": "Error saving Jurisdiction Payment Rules",
		"Error saving location": "Error saving location",
		"Error saving locations": "Error saving locations",
		"Error saving bank account details": "Error saving bank account details",
		"Error saving coordinator details": "Error saving coordinator details",
		"Error saving estimate": "Error saving estimate",
		"Error saving fees": "Error saving fees",
		"Error saving invoice": "Error saving invoice",
		"Error saving notes": "Error saving notes",
		"Error saving some of the invoice rules": "Error saving some of the invoice rules",
		"Error saving Location Zones": "Error saving Location Zones",
		"Error saving Scheduling Options": "Error saving Scheduling Options",
		"Error searching Officers": "Error searching Officers",
		"Error sending invoice": "Error sending invoice",
		"Error sending invoice(s)": "Error sending invoice(s)",
		"Error sending notification to the officer": "Error sending notification to the officer",
		"Error sending registration email": "Error sending registration email",
		"Error sending email": "Error sending email",
		"Error setting Preferred Card": "Error setting Preferred Card",
		"Error setting internal notes_": "Error setting internal notes.",
		"Error signing up user": "Error signing up user",
		"Error unapplying payment(s)": "Error unapplying payment(s)",
		"Error unarchiving estimate": "Error unarchiving estimate",
		"Error unassigning Officer": "Error unassigning Officer",
		"Error un-finalizing invoice": "Error un-finalizing invoice",
		"Error updating": "Error updating",
		"Error updating agency notes": "Error updating agency notes",
		"Error updating job application": "Error updating job application",
		"Error updating job applications": "Error updating job applications",
		"Error updating applicant status": "Error updating applicant status",
		"Error updating Blocked Status": "Error updating Blocked Status",
		"Error updating client": "Error updating client",
		"Error updating Coordination Fee": "Error updating Coordination Fee",
		"Error updating Multiple Locations": "Error updating Multiple Locations",
		"Error updating Officer": "Error updating Officer",
		"Error updating Tax Exemptions": "Error updating Tax Exemptions",
		"Error updating agency settings": "Error updating agency settings",
		"Error updating assignment rule": "Error updating assignment rule",
		"Error updating groups": "Error updating groups",
		"Error updating invoice": "Error updating invoice",
		"Error updating invoice rules": "Error updating invoice rules",
		"Error updating notification settings": "Error updating notification settings",
		"Error updating notifications": "Error updating notifications",
		"Error updating password": "Error updating password",
		"Error updating paycode": "Error updating paycode",
		"Error updating shift": "Error updating shift",
		"Error updating sing-up URL": "Error updating sing-up URL",
		"Error updating staggered Rule": "Error updating staggered Rule",
		"Error updating the jurisdiction": "Error updating the jurisdiction",
		"Error updating user": "Error updating user",
		"Error uploading Image": "Error uploading Image",
		"Error uploading client logo": "Error uploading client logo",
		"Error uploading document": "Error uploading document",
		"Error verifying bank account": "Error verifying bank account",
		"Error voiding estimate": "Error voiding estimate",
		"Error voiding": "Error voiding",
		"Error voiding call off": "Error voiding call off",
		Estimate: "Estimate",
		EstimateActionsBannerTitle: "Estimate Actions Available",
		EstimateActionsBannerDesc_: "An Estimate associated to this invoice has action items.",
		EstimateActionsBannerArchive_: "There is no refund but the estimate can be archived.",
		"Estimate Details": "Estimate Details",
		"Estimate is not refundable_": "Estimate is not refundable.",
		"Estimate has invoices not sent to client and paid_":
			"This Estimate is linked to an Invoice that has not been Paid.",
		"Estimate has pending payments_":
			"The Estimated Payment is still processing. The refund for this estimate can be done when the payment has succeeded.",
		"Estimate has refunds in transit_": "The Refund for this estimate is currently in Transit.",
		"Estimate has upcoming job present_": "Estimate has upcoming job present.",
		"Estimate not found_": "Estimate not found.",
		EstimateRefundAndArchiveModalTitle: "Refund and Archive Estimate",
		EstimateRefundAndArchiveModalMainButton: "Refund and Archive",
		EstimateRefundAndArchiveModalWithNoJobsWorkedMessage:
			"This estimate has a payment, but no jobs were worked. This estimate can now be refunded and archived.",
		"Estimate Refunded": "Estimate Refunded",
		"Estimate sent": "Estimate sent",
		"Estimate converted successfully": "Estimate converted successfully",
		"Estimate could not be found": "Estimate could not be found",
		"Estimate/Invoice number cannot be found": "Estimate/Invoice number cannot be found",
		"Estimate created successfully": "Estimate created successfully",
		"Estimate has been voided": "Estimate has been voided",
		"Estimate will be sent to": "Estimate will be sent to",
		"Estimated Amount": "Estimated Amount",
		"Estimated Officer Pay": "Estimated Officer Pay",
		"Estimated Service Fee": "Estimated Service Fee",
		"Estimated Subtotal": "Estimated Subtotal",
		"Estimated Tax": "Estimated Tax",
		"Estimated Total": "Estimated Total",
		"Estimated Workers' Compensation Fee": "Estimated Workers' Compensation Fee",
		Estimates: "Estimates",
		"Event Date": "Event Date",
		"Excluded Agencies": "Excluded Agencies",
		"Excluded Agency": "Excluded Agency",
		"Expand All": "Expand All",
		Experience: "Experience",
		"External Schedule": "External Schedule",
		"External Schedule Tooltip":
			"Enabling this will allow LEA's to include an officer's external schedule for assignment conflicts.",
		Expired: "Expired",
		Expires: "Expires",
		"Exclude Officer Pay on the Invoice": "Exclude Officer Pay on the Invoice",
		"Exclude officer pay from vehicle invoices": "Exclude officer pay from vehicle invoices",
		"Exclude officer pay modal message":
			"Selecting this option will exclude officer pay on the invoice for this job. Are you sure you want to exclude officer pay on the invoice?",
		"Exclude Officer Pay Add Jobs Modal Message":
			"This toggle is to group all jobs that have opted to exclude officer pay on the invoice together.",
		ExcludeOfficerPay: "Exclude Officer Pay",
		"Exclude Missing Government ID": "Exclude Missing Government ID",
		"Exclude Missing Supervisor Approval": "Exclude Missing Supervisor Approval",
		"Selecting a vehicle for this job will require vehicle invoicing_ Are you sure you want to include a vehicle on this job?":
			"Selecting a vehicle for this job will require vehicle invoicing. Are you sure you want to include a vehicle on this job?",
		"Failed to send reminder_": "Failed to send reminder.",
		Fee: "Fee",
		"Fee Amount": "Fee Amount",
		"Fee Totals": "Fee Totals",
		"Fee Type": "Fee Type",
		"Fee Type Invoice Summary": "Fee Type Invoice Summary",
		"Fee Type Payment Summary": "Fee Type Payment Summary",
		"Fee value cannot be negative": "Fee value cannot be negative",
		"Fee Rate": "Fee Rate",
		Fees: "Fees",
		"Fees Total": "Fees Total",
		"Fees and Taxes": "Fees and Taxes",
		"Fetching Officers___": "Fetching Officers...",
		"Finalize Agency Estimate": "Finalize Agency Estimate",
		"Finalize estimate modal message":
			"Finalizing this Agency Estimate will prevent further changes and create an invoice if any completed jobs are staffed. This estimate may have further action such as a refund if applicable.",
		"Fields not completed, please make sure all options are filled out correctly before saving":
			"Fields not completed, please make sure all options are filled out correctly before saving",
		Filled: "Filled",
		Filter: "Filter",
		"Filter by": "Filter by",
		"Filter by client to bulk send invoices": "Filter by client to bulk send invoices",
		"Filter by typing officer_s name to add to shift":
			"Filter by typing officer's name to add to shift",
		"Filtered by Locations": "Filtered by Locations",
		"Filtered by Radius": "Filtered by Radius",
		Filters: "Filters",
		"First Deposit": "First Deposit",
		"First Name": "First Name",
		"First Start Date": "First Start Date",
		FLEX: "FLEX",
		"Flex jobs allow the officer to work any time within the specified hours, and do not conflict with scheduled jobs":
			"Flex jobs allow the officer to work any time within the specified hours, and do not conflict with scheduled jobs",
		Float: "Float",
		Friday: "Friday",
		"Friday to Thursday": "Friday to Thursday",
		From: "From",
		"from the start of the job_": "from the start of the job.",
		"Front Image": "Front Image",
		"Full Calendar Month": "Full Calendar Month",
		"Full Calendar Year": "Full Calendar Year",
		"Fully Staffed": "Fully Staffed",
		"General Fees": "General Fees",
		"General Job Information": "General Job Information",
		"Generate Report": "Generate Report",
		"Generate Invoice": "Generate Invoice",
		"Give us feedback on this experience": "Give us feedback on this experience",
		Go: "Go",
		"Go Back": "Go Back",
		"Go to account settings if you need to update your default timezone":
			"Go to account settings if you need to update your default timezone.",
		"Go to rollkall dot com": "Go to rollkall.com",
		"Go to invoice": "Go to invoice",
		"Go to Estimate/Invoice #": "Go to Estimate/Invoice #",
		"Government Issued Id": "Government Issued Id",
		"Grand Total": "Grand Total",
		Grant: "Grant",
		"Great benefits await by using RollKall, including":
			"Great benefits await by using RollKall, including:",
		Group: "Group",
		"Group by Officer": "Group by Officer",
		"Group Name": "Group Name",
		"Group added successfully": "Group added successfully",
		"Group deleted successfully": "Group deleted successfully",
		"Group Send and Pay": "Group Send and Pay",
		"Group updated sucessfully": "Group updated sucessfully",
		Groups: "Groups",
		"Groups updated sucessfully": "Groups updated sucessfully",
		"Group Send and Pay is not available for V2 invoices":
			"Group Send and Pay is not available for V2 invoices.",
		"Has not provided verification form": "Has not provided verification form",
		"Have Officers Call": "Have Officers Call",
		Help: "Help",
		Hide: "Hide",
		"Hide from": "Hide from",
		"Hide officers": "Hide officers",
		"Hide password": "Hide password",
		"Hide Payment Methods": "Hide Payment Methods",
		"Hiring for": "Hiring for",
		History: "History",
		"Holiday Rates": "Holiday Rates",
		"Holiday Rates Tooltip":
			"Holiday rates that apply on specified job dates only. Overrides pre-existing Base Rates.",
		Hour: "Hour",
		"Hourly Limits": "Hourly Limits",
		"Hourly Limits Exceeded": "Hourly Limits Exceeded",
		"Hourly Rate": "Hourly Rate",
		"Hourly Restrictions": "Hourly Restrictions",
		"Hourly limits section needs at least one restriction_":
			"Hourly limits section needs at least one restriction.",
		Hours: "Hours",
		"hours per day": "hours per day",
		"hours per week": "hours per week",
		"hours per month": "hours per month",
		"Hours Required": "Hours Required",
		"Hours Worked": "Hours Worked",
		"Hours or days_": "Hours or days?",
		"hours, recurring every": "hours, recurring every",
		"How do you want to assign this officer_": "How do you want to assign this officer?",
		"How many hours do you limit your officers to per week_":
			"How many hours do you limit your officers to per week?",
		"How many locations do you currently coordinate EJs for_":
			"How many locations do you currently coordinate EJs for?",
		"How many officers do you need_": "How many officers do you need?",
		"How many shifts per week do you currently coordinate EJs for_":
			"How many shifts per week do you currently coordinate EJs for?",
		"How the client will be invoiced for this job":
			"How the client will be invoiced for this job",
		"How the officer(s) will be paid for their services":
			"How the officer(s) will be paid for their services",
		"How will payments take place_": "How will payments take place?",
		"How will this job get paid_": "How will this job get paid?",
		"How would you like the officers to call off_":
			"How would you like the officers to call off?",
		"How would you like the officers to remove themselves_":
			"How would you like the officers to remove themselves?",
		"How would you like the officers to request replacement_":
			"How would you like the officers to request replacement?",
		"How would you like to pay for this job_": "How would you like to pay for this job?",
		"How you would like to fill position(s)": "How you would like to fill position(s)",
		"Hubspot Integration": "Hubspot Integration",
		"Hr Minimum": "Hr Minimum",
		"I agree": "I agree",
		"I agree to the": "I agree to the",
		"I attest that I have full authorization to this account":
			"I attest that I have full authorization to this account",
		"I will post and or assign officers manually_":
			"I will post and/or assign officers manually.",
		"I acknowledge that the client is aware that they will be electronically invoiced for this job and is required to pay for all services rendered to them":
			"I acknowledge that the client is aware that they will be electronically invoiced for this job and is required to pay for all services rendered to them",
		ID: "ID",
		"If an external officer is assigned to the job, invoices cannot be paid online_":
			"If an external officer is assigned to the job, invoices cannot be paid online.",
		"If approval required, officer assignment will not be available until after estimate is approved_":
			"If approval required, officer assignment will not be available until after estimate is approved.",
		"If not filled": "If not filled",
		"If more than 1 officer is needed, multiple job postings will be created for each officer_":
			"If more than 1 officer is needed, multiple job postings will be created for each officer.",
		"If officer working hours are not restricted, the value must be at least 0_":
			"If officer working hours are not restricted, the value must be at least 0.",
		"If specific rank, select rank": "If specific rank, select rank",
		"If this job requires that the officer use a vehicle, please indicate the type of vehicle required_":
			"If this job requires that the officer use a vehicle, please indicate the type of vehicle required.",
		"If this option is selected, you can post to a specific group then delay posting to the whole department with the two options below":
			"If this option is selected, you can post to a specific group then delay posting to the whole department with the two options below",
		"If this option is not selected the job will unpost at the end of the sign up period, which may affect call off options_":
			"If this option is not selected the job will unpost at the end of the sign up period, which may affect call off options.",
		"If you would like to post First come first serve to a specific group, try building a staggered rule set_":
			"If you would like to post First come first serve to a specific group, try building a staggered rule set.",
		"If you want to pull from certain law enforcement agencies then list those agencies here and we_ll make sure only those officers can apply for the jobs_":
			"If you want to pull from certain law enforcement agencies then list those agencies here and we'll make sure only those officers can apply for the jobs.",
		"I_m done": "I'm done",
		Image: "Image",
		Impersonate: "Impersonate",
		"Impersonate User": "Impersonate User",
		Import: "Import",
		"Import PTAEO Codes": "Import PTAEO Codes",
		Inactive: "Inactive",
		"Inactive Clients Count": "Inactive Clients Count",
		"Inactive Projects": "Inactive Projects",
		"Inclement Weather": "Inclement Weather",
		"Include Deleted": "Include Deleted",
		"Include Inactive": "Include Inactive",
		"Include both on and off duty hours": "Include both on and off duty hours",
		"Exclude officer pay for required vehicle invoicing":
			"Exclude officer pay for required vehicle invoicing",
		Incomplete: "Incomplete",
		"Incomplete address": "Incomplete address",
		"Incomplete profile": "Incomplete profile",
		"Incorrect Agency ID": "Incorrect Agency ID",
		"Incorrect Profile Image": "Incorrect Profile Image",
		Indefinite: "Indefinite",
		"Individual Send": "Individual Send",
		Information: "Information",
		"Initial Status": "Initial Status",
		Insights: "Insights",
		Insurance: "Insurance",
		InstantPay: "InstantPay",
		InstantPayV1: "InstantPay V1",
		"Instant Pay Audit": "Instant Pay Audit",
		"InstantPay option for officers": "InstantPay option for officers",
		InstantPayV3: "InstantPay V3",
		"Officer v3 InstantPay": "Officer v3 InstantPay",
		"Input an invoice ID to determine reasons why a job did not qualify for Instant Pay":
			"Input an invoice ID to determine reasons why a job did not qualify for Instant Pay",
		"Input the following fields to see if an invoice/timecard is eligible for Instant Pay":
			"Input the following fields to see if an invoice/timecard is eligible for Instant Pay",
		"Internal Notes": "Internal Notes",
		"Invalid amount value": "Invalid amount value.",
		"Invalid Invoice Id": "Invalid Invoice Id",
		"Invalid Job Id": "Invalid Job Id",
		"Invalid User Id": "Invalid User Id",
		"Invalid activation link": "Invalid activation link",
		"Invalid username or password": "Invalid username or password",
		"Invalid value supplied for a fee": "Invalid value supplied for a fee",
		Invite: "Invite",
		"Invite to RollKall": "Invite to RollKall",
		Invoice: "Invoice",
		InvoiceV3: "InvoiceV3",
		OfficerInvoicing: "Officer invoicing V3",
		RollKallVerifies: "RollKall Verifies",
		"Invoice(s) Approved": "Invoice(s) Approved",
		"Invoice(s) sent": "Invoice(s) sent",
		"Invoice Attachments": "Invoice Attachments",
		"Invoice Details": "Invoice Details",
		"Invoice End Date": "Invoice End Date",
		"Invoice Estimate resent successfully": "Invoice Estimate resent successfully",
		"Invoice ID": "Invoice ID",
		"Invoice Issued": "Invoice Issued",
		"Invoice Number": "Invoice Number",
		"Invoice rules deleted successfully": "Invoice rules deleted successfully",
		"Invoice Paid": "Invoice Paid",
		"Invoice Payment Summary": "Invoice Payment Summary",
		"Invoice rules posted successfully": "Invoice rules posted successfully",
		"Invoice rules saved successfully": "Invoice rules saved successfully",
		"Invoice Recipient": "Invoice Recipient",
		"Invoice Recipients": "Invoice Recipient(s)",
		"Invoice Sent": "Invoice Sent",
		"Invoice Start Date": "Invoice Start Date",
		"Invoice Status": "Invoice Status",
		"Invoice could not be found": "Invoice could not be found",
		"Invoice created successfully": "Invoice created successfully",
		"Invoice Created": "Invoice Created",
		"Invoice due date must be on or after the issue date":
			"Invoice due date must be on or after the issue date",
		"Invoice History": "Invoice History",
		"Invoice rules updated successfully": "Invoice rules updated successfully",
		"Invoice or estimate must be saved before applying payment":
			"Invoice or estimate must be saved before applying payment",
		"Invoice status was changed to": "Invoice status was changed to",
		"Invoice successfully finalized": "Invoice successfully finalized",
		"Invoice successfully un-finalized": "Invoice successfully un-finalized",
		"Invoice successfully voided": "Invoice successfully voided",
		"Invoice Total": "Invoice Total",
		"Invoice Type": "Invoice Type",
		"Invoice updated successfully": "Invoice updated successfully",
		"Invoice was": "Invoice was",
		"Invoice was disputed": "Invoice was disputed",
		"Invoice will be sent to": "Invoice will be sent to",
		Invoiced: "Invoiced",
		"Invoiced Amount": "Invoiced Amount",
		"Invoiced Hours": "Invoiced Hours",
		"Invoiced by Agency": "Invoiced by Agency",
		"Invoiced by Officer": "Invoiced by Officer",
		Invoices: "Invoices",
		"Invoices Breakdown": "Invoice Breakdown",
		"Invoices Paid": "Invoices Paid",
		"Invoices Pending Approval": "Invoices Pending Approval",
		"Invoices Submitted": "Invoices Submitted",
		"Invoicing Details": "Invoicing Details",
		Invoicing: "Invoicing",
		"Invoicing Type": "Invoicing Type",
		"Invoicing Settings": "Invoicing Settings",
		"Invoice rules created successfully": "Invoice rules created successfully",
		"Invoice rule created successfully": "Invoice rule created successfully",
		"Invoice rule updated successfully": "Invoice rule updated successfully",
		"Invoice rule deleted successfully": "Invoice rule deleted successfully",
		"Invoice reporting that supports record-keeping and staying compliant with various financial regulations":
			"Invoice reporting that supports record-keeping and staying compliant with various financial regulations",
		"In a single transaction, multiple invoices will be emailed and individually payed by the recipients you choose_":
			"In a single transaction, multiple invoices will be emailed and individually payed by the recipients you choose.",
		"In a single transaction, a group of invoices will be emailed and payed in one payment by the recipient you choose_":
			"In a single transaction, a group of invoices will be emailed and payed in one payment by the recipient you choose.",
		"Is a supervisor required for this position_":
			"Is a supervisor required for this position?",
		"Is a vehicle required for this position_": "Is a vehicle required for this position?",
		"Is a client going to be paying for this job_":
			"Is a client going to be paying for this job?",
		"Is additional equipment required for this position_":
			"Is additional equipment required for this position?",
		"Is there a specific agency(ies) that you would like to use_":
			"Is there a specific agency(ies) that you would like to use?",
		"Is this a flexible shift_": "Is this a flexible shift?",
		"Is this a recurring job_": "Is this a recurring job?",
		"Is this a roving patrol position_": "Is this a roving patrol position?",
		"Is this a supervisory position": "Is this a supervisory position?",
		"Issue Date and Due Date are required to save an invoice":
			"Issue Date and Due Date are required to save an invoice",
		"Issue date required to create an estimate": "Issue date required to create an estimate",
		"Issue Refund": "Issue Refund",
		"issue refund": "issue refund",
		"Issue refund_": "Issue refund?",
		Issued: "Issued",
		"Item Name": "Item Name",
		"It_s helpful to remind officers whose invoices are Pending to submit their invoices for the client_s review_":
			"It's helpful to remind officers whose invoices are currently \"Pending Submission\" to submit their invoices for the client's review.",
		Job: "Job",
		"Job #": "Job #",
		"Job Activity": "Job Activity",
		"Job Approvals": "Job Approvals",
		"Job application approved": "Job application approved",
		"Job applications approved": "Job applications approved",
		"Job application denied": "Job application denied",
		"Job applications denied": "Job applications denied",
		"Job Contact": "Job Contact",
		"Job(s) Changed": "Job(s) Changed",
		"Job Date": "Job Date",
		"Job Date Range": "Job Date Range",
		"Job draft deleted": "Job draft deleted",
		"Job Description": "Job Description",
		"Job Details": "Job Details",
		"Job End Date": "Job End Date",
		"Job Estimates": "Job Estimates",
		"Job History": "Job History",
		"Job ID": "Job ID",
		"Job Location": "Job Location",
		"Job Log": "Job Log",
		"Job Name": "Job Name",
		"Job Requirements": "Job Requirements",
		"Job Site": "Job Site",
		"Job Start Date": "Job Start Date",
		"Job Tags": "Tags",
		"Job cancelled due to a State of Emergency": "Job cancelled due to a State of Emergency",
		"Job created successfully": "Job created successfully",
		"Job deleted successfully": "Job deleted successfully",
		"Job has been posted": "Job has been posted",
		"Job has not been posted": "Job has not been posted",
		"Job not found": "Job not found",
		"Job posted successfully": "Job posted successfully",
		"Job request deleted successfully": "Job request deleted successfully",
		"Job restored successfully": "Job restored successfully",
		"Job unposted successfully": "Job unposted successfully",
		"Job updated successfully": "Job updated successfully",
		"Job(s) posted successfully": "Job(s) posted successfully",
		Jobs: "Jobs",
		"Jobs Coordinated": "Jobs Coordinated",
		"Jobs List": "Jobs List",
		"Jobs Pending Approval": "Jobs Pending Approval",
		"Jobs Scheduled": "Jobs Scheduled",
		"Jobs Worked": "Jobs Worked",
		"Jobs with Exclude Officer Pay": "Jobs with Exclude Officer Pay",
		"Jobs can be only deleted by the agency that manages the job":
			"Jobs can be only deleted by the agency that manages the job",
		"Job enforceV2 options validation_":
			"These options are not available for manual invoicing.",
		"Job enforceV2 save validation_":
			"The invoicing type selected is not valid for this client because they have manual invoicing turned on. Please change the invoicing to Agency to continue.",
		Jurisdiction: "Jurisdiction",
		"Jurisdiction Fees": "Jurisdiction Fees",
		"Jurisdiction History": "Jurisdiction History",
		"Jurisdiction In-Service Date": "Jurisdiction In-Service Date",
		"Jurisdiction Vehicle Fees": "Jurisdiction Vehicle Fees",
		"Jurisdiction successfully created": "Jurisdiction successfully created",
		"Jurisdiction successfully deleted": "Jurisdiction successfully deleted",
		"Jurisdiction successfully moved and deleted":
			"Jurisdiction successfully moved and deleted",
		"Jurisdiction successfully updated": "Jurisdiction successfully updated",
		Jurisdictions: "Jurisdictions",
		Keep: "Keep",
		"Keep this client_": "Keep this client.",
		"Keep this group_": "Keep this group.",
		"Keep this location_": "Keep this location.",
		"Key Stats": "Key Stats",
		LEA: "LEA",
		Last: "Last",
		"Last Login": "Last Login",
		"Last Name": "Last Name",
		"Late Clock-In": "Late Clock-In",
		"Latest RK Version": "Latest RK Version",
		Latitude: "Latitude",
		Legacy: "Legacy",
		"Lengthy Job Confirmation": "Lengthy Job Confirmation",
		"Let RollKall do the heavy lifting of scheduling out a job that repeats daily or on specific days of the week":
			"Let RollKall do the heavy lifting of scheduling out a job that repeats daily or on specific days of the week.",
		"Limit # of Jobs": "Limit # of Jobs",
		"Limit officer to": "Limit officer to",
		"Limit to": " Limit to",
		Link: "Link",
		LinkedEstimateActionsModalTitle: "Linked Estimate Action Available",
		LinkedEstimateActionsModalBody_:
			"An Estimate Linked to this Invoice now has actions available.",
		LinkedEstimateActionsButton: "View Estimate",
		List: "List",
		"Link Bank Account": "Link Bank Account",
		"Load More": "Load More",
		Loading: "Loading",
		"Loading data": "Loading data",
		"Local Timezone": "Local Timezone",
		Location: "Location",
		"Location Address": "Location Address",
		"Location Approval": "Location Approval",
		"Location Details": "Location Details",
		"Location Management": "Location Management",
		"Location Name": "Location Name",
		"Location Payment Summary": "Location Payment Summary",
		"Location Restriction": "Location Restriction",
		"Location Restrictions": "Location Restrictions",
		"Location Type": "Location Type",
		"Location approved successfully": "Location approved successfully",
		"Location created successfully": "Location created successfully.",
		"Location denied successfully": "Location denied successfully",
		"Location not found": "Location not found",
		"Location sucessfully deleted": "Location sucessfully deleted",
		"Location Zone": "Location Zone",
		Locations: "Locations",
		"Locations Pending Approval": "Locations Pending Approval",
		"Location Zones saved successfully": "Location Zones saved successfully",
		"Lock all officer profiles": "Lock all officer profiles",
		"Lockout rules are not defined": "Lockout rules are not defined",
		"Lockout rules must have a unique number of calloffs":
			"Lockout rules must have a unique number of calloffs",
		Login: "Login",
		Logout: "Logout",
		Longitude: "Longitude",
		"Manual": "Manual",
		"Mail checks to": "Mail checks to",
		"Make Payment": "Make Payment",
		"Manage all of your officers": "Manage all of your officers",
		"Manage Assignments": "Manage Assignments",
		"Manage user schedules": "Manage user schedules",
		"Manage subscriptions": "Manage subscriptions",
		"Manage pay codes": "Manage pay codes",
		"Manage Posting": "Manage Posting",
		"Manage Vehicles": "Manage Vehicles",
		"Manage Zones": "Manage Zones",
		"Manual Assignment": "Manual Assignment",
		"Manually Add Account": "Manually Add Account",
		"Manual Invoicing": "Manual Invoicing",
		"Manage Invoicing Rules": "Manage Invoicing Rules",
		"Manual Payments": "Manual Payments",
		"Manually Assign Officers": "Manually Assign Officers",
		"Manually Invoiced clients can't use officer invoicing": "Manually Invoiced clients can't use officer invoicing",
		Map: "Map",
		"Map View": "Map View",
		"Marks funds for dispersment when balance is fully paid":
			"Marks funds for dispersment when balance is fully paid",
		"max size 100MB": "max size 100MB",
		"max rounds": "max rounds",
		"Maximum rank": "Maximum Rank",
		"Merge Contact": "Merge Contact",
		"Metadata Property": "Metadata Property",
		"Microdeposit amounts in cents": "Microdeposit amounts in cents",
		Migrate: "Migrate",
		"Migrate all officers to": "Migrate all officers to",
		Mile: "Mile",
		Miles: "Miles",
		Minimum: "Minimum",
		"Minimum Rank": "Minimum Rank",
		"Manage Rates": "Manage Rates",
		"Minimum Pay Rates": "Minimum Pay Rates",
		"Minimum Pay Rates Tooltip": "Minimum Pay Rates Tooltip",
		"Minimum Pay Rates Checkbox Tooltip":
			"Check this box if you would like to set a minimum pay rate for any jobs worked by your officers",
		"Misc Personnel": "Misc Personnel",
		"Missing Fees": "Missing Fees",
		"Manage job tags": "Manage job tags",
		Mobile: "Mobile",
		"Mobile App": "Mobile App",
		"Modification Date": "Modification Date",
		Modify: "Modify",
		Monday: "Monday",
		"Monday to Sunday": "Monday to Sunday",
		Monthly: "Monthly",
		"Monthly:": "Monthly:",
		"Month to date": "Month to date",
		"Most senior officers first": "Most senior officers first",
		"Least senior": "Least Senior",
		"Most senior": "Most senior",
		Move: "Move",
		Multiplier: "Multiplier",
		"Multiple Associated Invoice": "Multiple Associated Invoice",
		"Multiple Associated Invoices": "Multiple Associated Invoices",
		"Multiple Officers": "Multiple Officers",
		"Multiple Positions": "Multiple Positions",
		"My Groups": "My Groups",
		"My Officers Only": "My Officers Only",
		"Move to pending submission": "Move to pending submission",
		"My Officers have to acknowledge department rules before clocking into a job":
			"My Officers have to acknowledge department rules before clocking into a job",
		"Prevent officers from clocking-in into a job if they are offsite at the time of clocking-in":
			"Prevent officers from clocking-in into a job if they are offsite at the time of clocking-in",
		DenyOfficerFromClockingInTooltipMessage:
			"Enabling this setting prevents officers from clocking-in while offsite and prevents said officers from creating their own timecard on these affected jobs. However, a coordinator or supervisor can still create the officer's timecard and invoice these jobs.",
		Name: "Name",
		"Name for display can only includes alphanumeric characters, spaces, and the following permitted special characters_":
			"Name for display can only includes alphanumeric characters, spaces, and the following permitted special characters:",
		"Name for display cannot be longer than 60 characters":
			"Name for display cannot be longer than 60 characters",
		"Navigating to agency settings will lose any unsaved changes_":
			"Navigating to agency settings will lose any unsaved changes.",
		"Need to send to additional people_": "Need to send to additional people?",
		Needed: "Needed",
		Net: "Net",
		Never: "Never",
		New: "New",
		"New Agency Requirement": "New Agency Requirement",
		"New Announcement": "New Announcement",
		"New Asset": "New Asset",
		"New Estimate": "New Estimate",
		"New Excluded Agency": "New Excluded Agency",
		"New General Fee": "New General Fee",
		"New Group": "New Group",
		"New Invoice": "New Invoice",
		"New Job": "New Job",
		"New Job Tag": "New Job Tag",
		"New Location": "New Location",
		"New Lockout Rule": "New Lockout Rule",
		"New Password": "New Password",
		"New Project": "New Project",
		"New Rate": "New Rate",
		"New Rule": "New Rule",
		"New Shift": "New Shift",
		"New Vehicle Fee": "New Vehicle Fee",
		"Newly synced officers": "Newly synced officers",
		Next: "Next",
		"Next Payout": "Next Payout",
		No: "No",
		"No, Cancel": "No, Cancel",
		"No applicants received": "No applicants received",
		"No applicants history to display": "No applicants history to display",
		"No Attachments": "No Attachments",
		"No Clock-In": "No Clock-In",
		"No Contacts Available": "No Contacts Available",
		"No Image Available": "No Image Available",
		"No Jobs Selected": "No jobs selected",
		"No job tags defined": "No job tags defined",
		"No Limits": "No Limits",
		"No officers assigned": "No officers assigned",
		"No Officers Found": "No Officers Found",
		"No officers seeking replacement": "No officers seeking replacement",
		"No organization details": "No organization details",
		"No records found": "No records found",
		"No Restrictions": "No Restrictions",
		"No Timecards": "No Timecards",
		"No active jobs": "No active jobs",
		"No assets defined_": "No assets defined.",
		"No assignment rules": "No assignment rules",
		"No call offs registered": "No call offs registered",
		"No changes": "No changes",
		"No clients found": "No clients found",
		"No companies found": "No companies found",
		"No dashes (ex 998888888)": "No dashes (ex. 998888888)",
		"No data": "No data",
		"No deposit history to display": "No deposit history to display",
		"No email address associated with this agency":
			"No email address associated with this agency",
		"No excluded agencies": "No excluded agencies",
		"No fees added": "No fees added",
		"No invoices to display": "No invoices to display",
		"No job drafts found": "No job drafts found",
		"No job history to display": "No job history to display",
		"No jobs from the estimate were worked, so an invoice cannot be created from this estimate":
			"No jobs from the estimate were worked, so an invoice cannot be created from this estimate",
		"No jobs worked": "No jobs worked",
		"No longer an active officer": "No longer an active officer",
		"No longer with the registered agency": "No longer with the registered agency",
		"No notes": "No notes",
		"No notes found": "No notes found",
		"No notes found in this date range": "No notes found in this date range",
		"No officers have worked at this location": "No officers have worked at this location",
		"No attachments found": "No attachments found",
		"No payments found": "No payments found",
		"No required agencies": "No required agencies",
		"No rank": "No rank",
		"No response": "No response",
		"No results": "No results",
		"No results found": "No results found",
		"No rules found": "No rules found",
		"No status history": "No status history",
		"No Timecard Notes found": "No Timecard Notes found",
		"No timecard notes to display_": "No timecard notes to display.",
		"No statuses changes to display": "No statuses changes to display",
		"No vehicle fees": "No vehicle fees",
		"Non-agency level client": "Non-agency level client",
		"Non-RollKall Officer": "Non-RollKall Officer",
		"Non-RollKall Officers": "Non-RollKall Officers",
		"Non-vehicle fees must have an associated description":
			"Non-vehicle fees must have an associated description",
		"Non Profit": "Non Profit",
		"Nonrkpay invoice print title": "Print PDF",
		"Nonrkpay invoice print message":
			"This invoice has not been sent to the client, so the printed version of the invoice may have further modifications made. This printed invoice will come with a disclaimer at the bottom of the printed PDF.",
		"Nonrkpay invoice download pdf title": "Download PDF",
		"Nonrkpay invoice download pdf message":
			"This invoice has not been sent to the client and the PDF may have further modifications made. This download will come with a disclaimer at the bottom of the PDF.",
		"Not Available": "Not Available",
		"Not Set": "Not Set",
		"Not Staffed": "Not Staffed",
		Note: "Note",
		Note_: "Note:",
		"Note Added successfully": "Note Added successfully",
		"Note successfully deleted": "Note successfully deleted",
		"Note that all locations will inherit this rate_":
			"Note that all locations will inherit this rate.",
		"Note that if the job is recurring, this will schedule the posting of all future jobs as well_":
			"Note that if the job is recurring, this will schedule the posting of all future jobs as well.",
		Notes: "Notes",
		"Notes Saved": "Notes Saved",
		"Notes to Client": "Notes to Client",
		Notice: "Notice",
		Notifications: "Notifications",
		Notify: "Notify",
		Number: "Number",
		"Number Of Locations": "Number Of Locations",
		"N/A": "N/A",
		"OS Version": "OS Version",
		Occurrences: "Occurrences",
		Officer: "Officer",
		"Officer Approval & Assignment Rules": "Officer Approval & Assignment Rules",
		"Officer Approval & Posting Rules": "Officer Approval & Posting Rules",
		"Officer approved": "Officer approved",
		"Officer Call Off and Replacement": "Officer Call Off and Replacement",
		"Officer cannot be assigned to this job series due to a conflict with existing schedule assignments.":
			"Officer cannot be assigned to this job series due to a conflict with existing schedule assignments.",
		"Officer Certifications": "Officer Certifications",
		"Officer Details": "Officer Details",
		"Officer Email": "Officer Email",
		"Officer Fulfillment": "Officer Fulfillment",
		"Officer funds will be dispersed upon receiving payment for the invoice_":
			"Officer funds will be dispersed upon receiving payment for the invoice.",
		"Officer funds will be dispersed_": "Officer funds will be dispersed.",
		"Officer Groups": "Officer Groups",
		"Officer Hourly Fees": "Officer Hourly Fees",
		"Officer Hourly Total": "Officer Hourly Total",
		"Officer Hubspot Sync": "Officer Hubspot Sync",
		"No officers to sync": "No officers to sync",
		"Officer Insurance": "Officer Insurance",
		"Officer Invoicing": "Officer Invoicing",
		"Officer Management": "Officer Management",
		"Officer Miscellaneous Items": "Officer Miscellaneous Items",
		"Officer must call coordinator": "Officer must call coordinator",
		"Officer must find a replacement": "Officer must find a replacement",
		"Officer Name": "Officer Name",
		"Officer Notes": "Officer Notes",
		"Officer Penalties": "Officer Penalties",
		"Officer pay": "Officer pay",
		"Officer Pay": "Officer Pay",
		"Officer Rank": "Officer Rank",
		"Officer Rate": "Officer Rate",
		"Officer Rules": "Officer Rules",
		"Officer unapproved": "Officer unapproved",
		"Officer added to Do Not Hire list": "Officer added to Do Not Hire list",
		"Officer assigned successfully": "Officer assigned successfully",
		"Officer is on Do Not Hire list": "Officer is on Do Not Hire list",
		"Officer not found": "Officer not found",
		"Officer removed from Do Not Hire list": "Officer removed from Do Not Hire list",
		"Officer fees": "Officer fees",
		"Officer Fees": "Officer Fees",
		"Officer unassigned successfully": "Officer unassigned successfully",
		Officers: "Officers",
		"Officers are restricted from working more than":
			"Officers are restricted from working more than",
		"Officers Assigned": "Officers Assigned",
		"Officers Needed": "Officers Needed",
		"Officers Pending Verification": "Officers Pending Verification",
		"Officers Worked": "Officers Worked",
		"Officer Invoice IP": "Officer Invoice IP",
		"Officers can apply for the job": "Officers can apply for the job",
		"Officers can apply for the job, and will be shown to you in a list_":
			"Officers can apply for the job, and will be shown to you in a list.",
		"Officers can apply for the job, which will then be automatically assigned to the officer with the fewest number of hours_":
			"Officers can apply for the job, which will then be automatically assigned to the officer with the fewest number of hours.",
		"Officers can apply for the job, which will then be automatically assigned to the officer with the fewest number of jobs_":
			"Officers can apply for the job, which will then be automatically assigned to the officer with the fewest number of jobs.",
		"Officers can call off of a job with no actions required after call off_":
			"Officers can call off of a job with no actions required after call off.",
		"Officers can call off through the app with no additional actions required":
			"Officers can call off through the app with no additional actions required",
		"Officers on your Favorites will see this job first but after the specified number of hours":
			"Officers on your Favorites will see this job first but after the specified number of hours,",
		"Officer Web Portal": "Officer Web Portal",
		"Officers will be assigned randomly after the signup period is closed":
			"Officers will be assigned randomly after the signup period is closed",
		"Officers will be unassigned from a job if the call off is made more than":
			"Officers will be unassigned from a job if the call off is made more than",
		"Officers with least number of years first": "Officers with least number of years first",
		"Officers get a round to make all of their picks, prioritized by the order in which they apply and limited by the following options":
			"Officers get a round to make all of their picks, prioritized by the order in which they apply and limited by the following options",
		"Officers can qualify to receive instant payments":
			"Officers can qualify to receive instant payments",
		"Officers can choose to have RKInsurance coverage while they work":
			"Officers can choose to have RKInsurance coverage while they work",
		"Officer and Agency Jobs cannot be added to a single Estimate/Invoice":
			"Officer and Agency Jobs cannot be added to a single Estimate/Invoice",
		OK: "OK",
		Ok: "Ok",
		"Officers not created": "Officers not created",
		"Officers on Invoice": "Officers on Invoice",
		"Old Password": "Old Password",
		On: "On",
		"On duty Schedule Integration": "On duty Schedule Integration",
		"On-duty Shift": "On-duty Shift",
		"On Site": "On Site",
		"Once this invoice is finalized, no further modifications can be made_":
			"Once this invoice is finalized, no further modifications can be made.",
		'Once "Un-finalized", the invoice will move back into a Pending status, and can be accessed under the "Pending" tab on the Invoice List page':
			'Once "Un-finalized", the invoice will move back into a Pending status, and can be accessed under the "Pending" tab on the Invoice List page',
		"One or more locations you selected has jobs with officers assigned_":
			"One or more locations you selected has jobs with officers assigned.",
		"One or more selected jobs is part of a recurring series_":
			"One or more selected jobs is part of a recurring series.",
		"One type of vehicle cannot have multiple fees defined for it_":
			"One type of vehicle cannot have multiple fees defined for it.",
		"One or more selected positions have a pay code outside the start date range, please change it to a valid one":
			"One or more selected positions have a pay code outside the start date range, please change it to a valid one",
		"Only RK Verified": "Only RK Verified",
		"The selected pay code is outside the start date range, please change it to a valid one":
			"The selected pay code is outside the start date range, please change it to a valid one",
		"The link to all of these attachments will be sent to your email":
			"The link to all of these attachments will be sent to your email",
		Only: "Only",
		"Only Archived": "Only Archived",
		"Only authorized clients are allowed to use vehicles":
			"Only authorized clients are allowed to use vehicles",
		"Only count hours for jobs posted with this rule":
			"Only count hours for jobs posted with this rule",
		"Only Disputed": "Only Disputed",
		"Only Prepaid": "Only Prepaid",
		"Only RollKall Officers can be assigned to a pre-paid job_":
			"Only RollKall Officers can be assigned to a pre-paid job.",
		"Only allow jobs created by my agency": "Only allow jobs created by my agency",
		"Only allow jobs in these cities/counties": "Only allow jobs in these cities/counties",
		"Only groups can see it (never open to all)": "Only groups can see it (never open to all)",
		"Only the selected instances of this job": "Only the selected instances of this job",
		"Only this job": "Only this job",
		"Only those officers in a specific group will be able to view and/or apply to work this job":
			"Only those officers in a specific group will be able to view and/or apply to work this job",
		"Open to all officers": "Open to all officers",
		"Open while active": "Open while active",
		"Opting out of electronic invoicing and payments through the RollKall platform means missing out on_":
			"Opting out of electronic invoicing and payments through the RollKall platform means missing out on:",
		"or less from the start of the job_": "or less from the start of the job.",
		Order: "Order",
		"Order Summary": "Order Summary",
		Organization: "Organization",
		"Organization Fees": "Organization Fees",
		"Organization ID": "Organization ID",
		"Organization deleted successfully": "Organization deleted successfully",
		Organizations: "Organizations",
		"Organizations List": "Organizations List",
		"Organization Settings": "Organization Settings",
		Other: "Other",
		"Other fees": "Other fees",
		"Other Fees": "Other Fees",
		"Other Method": "Other Method",
		"Other Payment Method": "Other Payment Method",
		"Other Requirements": "Other Requirements",
		"Other Settings": "Other Settings",
		"Officer Pay Excluded": "Officer Pay Excluded *",
		Overtime: "Overtime",
		"Overpaid Invoices": "Overpaid Invoices",
		"Overpaid Estimate Balance": "Overpaid Estimate Balance",
		PID: "PID",
		"PO Number": "PO Number",
		Paid: "Paid",
		"Paid on": "Paid on",
		"Paid Status": "Paid Status",
		Password: "Password",
		"Password must be at least 6 characters long":
			"Password must be at least 6 characters long",
		"Password must be stronger": "Password must be stronger",
		"Password successfully reset": "Password successfully reset",
		"Passwords do not match": "Passwords do not match",
		"Pay All": "Pay All",
		"Pay Codes": "Pay Codes",
		"Pay Code Status": "Pay Code Status",
		"Pay Invoice": "Pay Invoice",
		"Pay Code": "Pay Code",
		"Pay Code Short Code": "Pay Code Short Code",
		"Pay Code Description": "Pay Code Description",
		"Pay Now": "Pay Now",
		"Pay Type": "Pay Type",
		"Pay Selected": "Pay Selected",
		"Paycode deleted successfully": "Paycode deleted successfully",
		"Paycode updated successfully": "Paycode updated successfully",
		"Paycode created successfully": "Paycode created successfully",
		"Payment Details": "Payment Details",
		"Payment Failed": "Payment Failed",
		"Payment History": "Payment History",
		"Payment Instructions": "Payment Instructions",
		"Payment Method": "Payment Method",
		"Payment Method added successfully": "Payment Method added successfully",
		"Payment Methods": "Payment Methods",
		"Payment Summary": "Payment Summary",
		"Payment Terms": "Payment Terms",
		"Payment and Invoicing": "Payment and Invoicing",
		"Payment applied successfully": "Payment applied successfully",
		"Payment complete": "Payment complete",
		"Payment is required 72 hours before a job starts":
			"Payment is required 72 hours before a job starts",
		"Payment method successfully deleted": "Payment method successfully deleted",
		"Payment processing": "Payment processing",
		"Payment was successful": "Payment was successful",
		"Payment(s) unapplied successfully": "Payment(s) unapplied successfully",
		Payments: "Payments",
		"Payments & Invoice Settings": "Payments & Invoice Settings",
		"PDF only*": "PDF only*",
		"PDF Disclaimer message for invoices not sent to clients":
			"This invoice was downloaded prior to being sent to the client and there may be discrepancies from the invoice that the client has received. For the most up to date invoice, please refer back to the Agency portal.",
		"PDF Disclaimer message for estimates not sent to clients":
			"This estimate was downloaded prior to being sent to the client and there may be discrepancies from the estimate that the client has received.",
		Penalized: "Penalized",
		Pending: "Pending",
		"Pending payments must be fully processed before issuing refund":
			"Pending payments must be fully processed before issuing refund",
		"Pending Applicants": "Pending Applicants",
		"Pending Approval": "Pending Approval",
		"Pending Payment": "Pending Payment",
		"Pending Officer Submission": "Pending Officer Submission",
		"Percentage based fees must be between 0 and 100":
			"Percentage based fees must be between 0 and 100",
		Personnel: "Personnel",
		"Personnel can override on-duty scheduling conflicts":
			"Personnel can override on-duty scheduling conflicts",
		"Personnel Misc": "Personnel Misc",
		Permit: "Permit",
		"Permitted To change": "Permitted To change",
		"Personnel Name": "Personnel Name",
		"Per job and per hour rates cannot be less than 0":
			"Per job and per hour rates cannot be less than 0",
		Phone: "Phone",
		"Phone Number": "Phone Number",
		"Phone Or Email": "Phone Or Email",
		"Photo ID (Evidence Quality)": "Photo ID (Evidence Quality)",
		Ping: "Ping",
		Pings: "Pings",
		Platform: "Platform",
		"Please add your available equipment/assets in your Agency Settings":
			"Please add your available equipment/assets in your Agency Settings",
		"Please add a description for this refund": "Please add a description for this refund.",
		"Please be aware that you are changing the rate for a position that already has officers assigned to it_":
			"Please be aware that you are changing the rate for a position that already has officers assigned to it.",
		"Please set a call off grace period": "Please set a call off grace period",
		"Please confirm this is the correct address_":
			"Please confirm this is the correct address:",
		"Please customize cancellation lockout rules._":
			"Please customize cancellation lockout rules.",
		"Please contact an LEA admin to make this assignment_":
			"Please contact an LEA admin to make this assignment.",
		"Please ensure the selected image has one of the following file extensions:":
			"Please ensure the selected image has one of the following file extensions:",
		"Please ensure all required information is provided":
			"Please ensure all required information is provided",
		"Please enter a reason why the officer is put on hold":
			"Please enter a reason why the officer is put on hold",
		"Please enter your first and last name": "Please enter your first and last name",
		"Please note that rate entered will be shared with the client on the invite and all the invoices, and will be added to the hourly officer rate_":
			"Please note that rate entered will be shared with the client on the invite and all the invoices, and will be added to the hourly officer rate.",
		"Please note that the rate entered will be shared with the client on the invitation as well as all invoices_":
			"Please note that the rate entered will be shared with the client on the invitation as well as all invoices.",
		"Please provide details": "Please provide details",
		"Please provide general traffic control at the corner of the street and parking garage_":
			"Please provide general traffic control at the corner of the street and parking garage.",
		"Please provide your agency’s billing email address":
			"Please provide your agency’s billing email address",
		"Please select all the categories of establishments that apply":
			"Please select all the categories of establishments that apply",
		"Please select all the vehicles types that apply":
			"Please select all the vehicles types that apply",
		"Please select a supervisor": "Please select a supervisor",
		"Please select a timeframe for cancellation lockout to be in effect_":
			"Please select a timeframe for cancellation lockout to be in effect.",
		"Please select a valid reason": "Please select a valid reason.",
		"Please select invoices with the same client to continue":
			"Please select invoices with the same client to continue",
		"Please select one of the reasons": "Please select one of the reasons",
		"Please select the assets/equipment required":
			"Please select the assets/equipment required",
		"Please select which method you would like to use to send your invoices_":
			"Please select which method you would like to use to send your invoices.",
		"Please share the reason for not utilizing the RollKall platform for online invoicing_":
			"Please share the reason for not utilizing the RollKall platform for online invoicing.",
		"Please specify a reason": "Please specify a reason:",
		"Please type a location name in order to see options":
			"Please type a location name in order to see options",
		"Please update your address in account settings to modify restricted location restrictions":
			"Please update your address in account settings to modify restricted location restrictions",
		Portals: "Portals",
		Position: "Position",
		"Position Name": "Position Name",
		Positions: "Positions",
		Post: "Post",
		"Post At A Specific Date/Time": "Post At A Specific Date/Time",
		"Post Immediately": "Post Immediately",
		"Post Job": "Post Job",
		"Post Selected": "Post Selected",
		"Post Time": "Post Time",
		"Post at": "Post at",
		"Post on": "Post on",
		"Posting Rules": "Posting Rules",
		"Posting Rules and Staggered Posting": "Posting Rules and Staggered Posting",
		"Post to all officers if not filled": "Post to all officers if not filled",
		"Post with Assignment Rule": "Post with Assignment Rule",
		"Post with posting rule": "Post with posting rule",
		Posted: "Posted",
		"Posted By": "Posted By",
		"Posted Status": "Posted Status",
		"Posted to All Officer Groups": "Posted to All Officer Groups",
		Prepaid: "Prepaid",
		Prepay: "Prepay",
		"Prevent officer assignment override": "Prevent officer assignment override",
		Preview: "Preview",
		"Preview Invoice": "Preview Invoice",
		Previous: "Previous",
		"Previous value": "Previous value",
		"Previously synced officers": "Previously synced officers",
		Price: "Price",
		"Primary Agency Supervisor": "Primary Agency Supervisor",
		"Primary Client Supervisor": "Primary Client Supervisor",
		"Primary contact updated successfully": "Primary contact updated successfully",
		"Primary Contact": "Primary Contact",
		Print: "Print",
		"Print Estimate": "Print Estimate",
		"Print Invoice": "Print Invoice",
		"Privacy Policy": "Privacy Policy",
		Proceed: "Proceed",
		"Processing fee updated successfully": "Processing fee updated successfully",
		"Profile Completed": "Profile Completed",
		"Profile Photo": "Profile Photo",
		Project: "Project",
		"Project Details": "Project Details",
		"Project Name": "Project Name",
		"Project Number": "Project Number",
		"Project Start Date": "Project Start Date",
		"Project successfully updated": "Project successfully updated",
		"Project sucessfully created": "Project sucessfully created",
		"Project sucessfully deleted": "Project sucessfully deleted",
		Projects: "Projects",
		Property: "Property",
		"Property Name": "Property Name",
		"PTAEO Code": "PTAEO Code",
		"PTAEO codes": "PTAEO codes",
		"PTAEO codes imported successfully": "PTAEO codes imported successfully",
		Push: "Push",
		"Push Notifications": "Push Notifications",
		"Put Officer on Hold": "Put Officer on Hold",
		"Putting this officer on hold will unassign them from their upcoming jobs_":
			"Putting this officer on hold will unassign them from their upcoming jobs.",
		"Payments Applied": "Payments Applied",
		Quantity: "Quantity",
		"QC Days": "QC Days",
		"QC Max Assignments": "QC Max Assignments",
		"QC #": "QC #",
		"QC Start": "QC Start",
		"RK Comments": "RK Comments",
		"RKInsurance transfer successfully initiated":
			"RKInsurance transfer successfully initiated.",
		RKPay: "RKPay",
		"RKPay Direct Deposit": "RKPay Direct Deposit",
		"RKPay Enabled": "RKPay Enabled",
		"RKPay Invite": "RKPay Invite",
		"RKPay Prepay": "RKPay Prepay",
		"RKPay Rate": "RKPay Rate",
		"RKPay rate not found": "RKPay rate not found",
		Radius: "Radius",
		Randomly: "Randomly",
		Rank: "Rank",
		"Rank Locked": "Rank Locked",
		Rate: "Rate",
		"Rate/Hr": "Rate/Hr",
		"Rate value cannot be negative": "Rate value cannot be negative",
		"Re-Calculate Totals": "Re-Calculate Totals",
		"Re-Verify": "Re-Verify",
		"Rate value has to be positive": "Rate value has to be positive",
		Reason: "Reason",
		"Reason Type Required": "Reason Type Required",
		"Reason for Dispute": "Reason for Dispute",
		"Reason for un-finalizing invoice": "Reason for un-finalizing invoice",
		"Disable Instant Pay Reason": "Disable Instant Pay Reason",
		Reassign: "Reassign",
		"Reassign Officer": "Reassign Officer",
		"Reassign Jobs": "Reassign Jobs",
		Receipt: "Receipt",
		Recurrence: "Recurrence",
		"Recurrence ID": "Recurrence ID",
		Recurring: "Recurring",
		"Recursive Job Confirmation": "Recursive Job Confirmation",
		"Redirect Confirmation": "Redirect Confirmation",
		"Redirecting to new user": "Redirecting to new user",
		"Restrict what jobs my officers can work on the platform":
			"Restrict what jobs my officers can work on the platform",
		Refund: "Refund",
		"Refund(s)": "Refund(s)",
		"Refund Amount": "Refund Amount",
		"Refund Due": "Refund Due",
		"Refund failed": "Refund failed",
		"Refund initiated": "Refund initiated",
		"Refund NonRKPayInvoiceEstimateModal title": "Refund Estimate",
		"Refund NonRKPayInvoiceEstimateModal body message":
			"This estimate has been paid but the jobs have not been worked.",
		"Refund NonRKPayInvoiceEstimateModal checkbox": "Archive this estimate after refunding",
		"Refund NonRKPayInvoiceEstimateModal confirm button": "Refund Estimate",
		"Refund successful": "Refund successful",
		Refunding: "Refunding...",
		"Refund Balance": "Refund Balance",
		"Registered Devices": "Registered Devices",
		"Registration email sent": "Registration email sent",
		Reject: "Reject",
		Rejected: "Rejected",
		Remind: "Remind",
		"Remind Officer": "Remind Officer",
		"Reminder sent_": "Reminder sent.",
		Remove: "Remove",
		"Remove Completely": "Remove Completely",
		"Remove Image": "Remove Image",
		"Remove Note": "Remove Note",
		"Remove all officers": "Remove all officers",
		"Remove if Replacement is Found": "Remove if Replacement is Found",
		"Remove officer from specific groups by unchecking the group_":
			"Remove officer from specific groups by unchecking the group.",
		"Remove rule": "Remove rule",
		Repeats: "Repeats",
		"Repeats Every": "Repeats Every",
		"Repeats On": "Repeats On",
		Reports: "Reports",
		"Report Type": "Report Type",
		"Report file successfully generated": "Report file successfully generated",
		"Reports to another position": "Reports to another position",
		"Request limit reached": "Request limit reached",
		"Request tax exempt status by uploading the required documentation":
			"Request tax exempt status by uploading the required documentation",
		"Request Prepay": "Request Prepay",
		"Request Prepay Tooltip_":
			"By selecting this option the client will be able to apply a payment to this estimate.",
		Requested: "Requested",
		"Requested Date": "Requested Date",
		"Requested change will take effect pending officer acceptance_":
			"Requested change will take effect pending officer acceptance.",
		"Require Annual Verification Process": "Require Annual Verification Process",
		"Require Estimate Approval": "Require Estimate Approval",
		"Require Prepay": "Require Prepay",
		"Require invoicing for vehicles": "Require invoicing for vehicles",
		"Required Agencies": "Required Agencies",
		Requirements: "Requirements",
		"Requires Prepayment": "Requires Prepayment",
		"Requires RKPay": "Requires RKPay",
		"Requires deposit information": "Requires deposit information",
		"Requires prepayment": "Requires prepayment",
		"Requires Pre-payment": "Requires Pre-payment",
		"Require vehicle number when clocking in": "Require vehicle number when clocking in",
		"Require vehicle miles when clocking in and out of a job":
			"Require vehicle miles when clocking in and out of a job",
		Rescheduled: "Rescheduled",
		"Rescheduled for another day": "Rescheduled for another day",
		Resend: "Resend",
		"Resend Invite": "Resend Invite",
		"Reset call offs every month": "Reset call offs every month",
		"Reset call offs every year": "Reset call offs every year",
		"Reset call offs on the given date": "Reset call offs on the given date",
		"Reset Password": "Reset Password",
		Restore: "Restore",
		"Restore Job": "Restore Job",
		"Restore Jobs": "Restore Jobs",
		"Restrict to this rank only": "Restrict to this rank only",
		"Result Area": "Result Area",
		"Return to Estimate": "Return to Estimate",
		"Reveal password": "Reveal password",
		Reverify: "Reverify",
		"Review Now": "Review Now",
		"Review Payment": "Review Payment",
		"Review officer invoices prior to client payment":
			"Review officer invoices prior to client payment",
		Role: "Role",
		"Rolling 365": "Rolling 365",
		"RK Account": "RK Account",
		"RKInsurance refund": "RKInsurance refund",
		"RKInsurance coverage option for off-duty jobs":
			"RKInsurance coverage option for off-duty jobs",
		"RollKall Fees": "RollKall Fees",
		"RollKall For Coordinator": "RollKall For Coordinator",
		"RollKall For LEA": "RollKall For LEA",
		"RollKall Officers": "RollKall Officers",
		"RollKall collects money on behalf of officers_":
			"RollKall collects money on behalf of officers.",
		"RollKall has encountered an error_ Our team has been notified of this issue_":
			"RollKall has encountered an error. Our team has been notified of this issue.",
		"RollKall Reports": "RollKall Reports",
		"Routing Number": "Routing Number",
		"Roving Patrol": "Roving Patrol",
		"Roving Patrol Jobs require you to set radius in miles":
			"Roving Patrol Jobs require you to set radius in miles",
		"Row removed successfully": "Row removed successfully",
		"Run this rule for": "Run this rule for",
		"Rule Date": "Rule Date",
		"Rule Date Range": "Rule Date Range",
		"Remind client": "Remind client",
		"Remind Client": "Remind Client",
		"Recalculate Invoice": "Recalculate Invoice",
		SMS: "SMS",
		Saturday: "Saturday",
		"Saturday to Friday": "Saturday to Friday",
		Save: "Save",
		"Save a new invoice": "Save a new invoice",
		"Save and Apply Payment": "Save and Apply Payment",
		"Save and apply updates": "Save and apply updates",
		"Save and Download": "Save and Download",
		"Save and Print": "Save and Print",
		"Save and Send": "Save and Send",
		"Save and Finalize": "Save and Finalize",
		"Save Changes": "Save Changes",
		"Save Estimate": "Save Estimate",
		"Save Invoice": "Save Invoice",
		"Save Job": "Save Job",
		"Save or discard your changes to the current New Fee":
			"Save or discard your changes to the current New Fee",
		"Save your changes before sending to": "Save your changes before sending to",
		"Save Schedule Only Options": "Save Schedule Only Options",
		"save and finalize estimate body":
			"There are unsaved changes on this estimate. Would you like to save and finalize this estimate?",
		"Saving these changes may delete some jobs and override previous changes_":
			"Saving these changes may delete some jobs and override previous changes.",
		"Saving these changes may overwrite some previous changes to jobs_":
			"Saving these changes may overwrite some previous changes to jobs.",
		Schedule: "Schedule",
		"Schedule Only": "Schedule Only",
		"Schedule Only Options": "Schedule Only Options",
		"Schedule Only Option Save Message":
			"These fields have been saved as a default for this client. Any future jobs created will have these prefilled. To change these fields please visit the client details page to edit your default settings for this client's invoicing.",
		Scheduled: "Scheduled",
		"Scheduled End": "Scheduled End",
		"Scheduled Hours": "Scheduled Hours",
		"Scheduled Start": "Scheduled Start",
		"Scheduled Time": "Scheduled Time",
		"Scheduling Only": "Scheduling Only",
		"Scheduling Only Defaults": "Scheduling Only Defaults",
		"WC Fee": "WC Fee",
		"Workers' Compensation Fee": "Workers' Compensation Fee",
		"Workers' Compensation Fees": "Workers' Compensation Fees",
		"Workers Protection": "Workers Protection",
		Search: "Search",
		"Search by Shift Name": "Search by Shift Name",
		"Search by Supervisor": "Search by Supervisor",
		"Search Clients": "Search Clients",
		"Search pay code": "Search pay code",
		"Search Jurisdictions": "Search Jurisdictions",
		"Search Location": "Search Location",
		"Search Officer": "Search Officer",
		"Search Officers": "Search Officers",
		"Search by Name": "Search by Name",
		"Search by officer": "Search by officer",
		"Search by officer name or email": "Search by officer name or email",
		"Search for a jurisdiction to move the officers into":
			"Search for a jurisdiction to move the officers into",
		"Search for Officer": "Search for Officer",
		"Search results will appear here": "Search results will appear here",
		"Search and select a specific replacement": "Search and select a specific replacement",
		"Second Deposit": "Second Deposit",
		"Secondary Approval": "Secondary Approval",
		"Security Agency": "Security Agency",
		"Security Agency Signup": "Security Agency Signup",
		"Secure payment processing": "Secure payment processing",
		"Secure online payment processing": "Secure online payment processing",
		"See all activities on this invoice": "See all activities on this invoice",
		"See older paid invoices in reports": "See older paid invoices in reports",
		Select: "Select",
		"Select Agency": "Select Agency",
		"Select All": "Select All",
		"Select Client": "Select Client",
		"Select Clock-In Status": "Select Clock-In Status",
		"Select Contact": "Select Contact",
		"Select Coordinators": "Select Coordinators",
		"Select Groups": "Select Groups",
		"Select Location": "Select Location",
		"Select Payment Method": "Select Payment Method",
		"Select Position": "Select Position",
		"Select Project": "Select Project",
		"Select Reason": "Select Reason",
		"Select State": "Select State",
		"Select Supervisor": "Select Supervisor",
		"Select a certification": "Select a certification",
		"Select a client to add jobs": "Select a client to add jobs",
		"Select a reason": "Select a reason",
		"Select a Job Restriction option in the Agency restrictions section":
			"Select a Job Restriction option in the Agency restrictions section",
		"Select a vehicle type": "Select a vehicle type",
		"Select an organization and provide at least one other value to search":
			"Select an organization and provide at least one other value to search",
		"Select a week day": "Select a week day",
		"Select as Payment Method": "Select as Payment Method",
		"Select at least one group": "Select at least one group",
		"Select at least one invoice": "Select at least one invoice",
		"Select at least one payment to be unapplied":
			"Select at least one payment to be unapplied",
		"Select day": "Select day",
		"Select payment method to continue": "Select payment method to continue",
		"Select the certifications required": "Select the certifications required",
		"Select the groups you would like the officer to be added_":
			"Select the groups you would like the officer to be added.",
		"Select the restricted locations": "Select the restricted locations",
		"Selected Locations approved successfully": "Selected Locations approved successfully",
		"Selected Locations denied successfully": "Selected Locations denied successfully",
		"Selecting this option will cause payments to be sent to the Agency instead of the officers. Are you sure you want to enable this_":
			"Selecting this option will cause payments to be sent to the Agency instead of the officers. Are you sure you want to enable this?",
		"Selecting this option will cause payments to be sent to the officer instead of the agency. Are you sure you want to disable this_":
			"Selecting this option will cause payments to be sent to the officer instead of the agency. Are you sure you want to disable this?",
		Send: "Send",
		"Send Estimate": "Send Estimate",
		"Send Invoice": "Send Invoice",
		"Send Invoices": "Send Invoice(s)",
		"Send Invoice to": "Send Invoice to",
		"Send Method": "Send Method",
		"Send Notification": "Send Notification",
		"Send Request": "Send Request",
		"Send Selected": "Send Selected",
		"Send Test Notification": "Send Test Notification",
		"Send a message to officers": "Send a message to officers",
		"Send as Single Invoice": "Send as Single Invoice",
		"Send estimate to": "Send estimate to",
		"Seniority Draft": "Seniority Draft",
		Sent: "Sent",
		"Sent Date": "Sent Date",
		"Sent To": "Sent To",
		"Series Total": "Series Total",
		"Service Details": "Service Details",
		Service: "Service",
		"Service Fee": "Service Fee",
		"Service fees": "Service fees",
		"Service Fees": "Service Fees",
		"Service Tax": "Service Tax",
		"Session Expired": "Session Expired",
		"Set Client Contact to Invite": "Set Client Contact to Invite",
		"Set Coordination Fee": "Set Coordination Fee",
		"Set Default": "Set Default",
		"Set Hourly Coordination Fee": "Set Hourly Coordination Fee",
		"Set Paycode": "Set Paycode",
		"Set Radius": "Set Radius",
		"Set Recipients For All": "Set Recipients For All",
		"Set as preferred": "Set as preferred",
		"Set as Primary Contact": "Set as Primary Contact",
		"Set up a default set of agency restrictions for your jobs_":
			"Set up a default set of agency restrictions for your jobs.",
		"Set up how officers can call off of upcoming jobs_":
			"Set up how officers can call off of upcoming jobs.",
		"Set up what jobs your officers can work in the platform_":
			"Set up what jobs your officers can work in the platform.",
		"Set up when specific agency’s officers can apply to your jobs_":
			"Set up when specific agency’s officers can apply to your jobs.",
		"Set/Update your fees for clients requesting to hire your officers_":
			"Set/Update your fees for clients requesting to hire your officers.",
		"Set/Update your paycodes": "Set/Update your paycodes",
		"Settings Menu": "Settings Menu",
		"Setup Shift": "Setup Shift",
		Shift: "Shift",
		"Shift Management": "Shift Management",
		"Shift Name": "Shift Name",
		"Shift deleted successfully": "Shift deleted successfully",
		"Shifts Per Week": "Shifts Per Week",
		"Short Code": "Short Code",
		Show: "Show",
		"Show Jobs 180+ Days": "Show Jobs 180+ Days",
		"Show Client Contact to Officer": "Show Client Contact to Officer",
		"Show officers": "Show officers",
		"Show only to": "Show only to",
		"Show Payment Methods": "Show Payment Methods",
		"Show Receipt": "Show Receipt",
		"Only Voided": "Only Voided",
		"Sign In": "Sign In",
		"Sign in to your bank account using your credentials":
			"Sign in to your bank account using your credentials",
		"Sign Up": "Sign Up",
		"Sign-Up For RKPay": "Sign-Up For RKPay",
		"Sign-Up Period": "Sign-Up Period",
		"Sign-up URL": "Sign-up URL",
		"Sing-up URL updated successfully": "Sing-up URL updated successfully",
		"Simplified creation and management of invoices":
			"Simplified creation and management of invoices",
		"Simplified invoice creation and management": "Simplified invoice creation and management",
		"Simplified invoice creation and secure online payment of invoices with automated reminders":
			"Simplified invoice creation and secure online payment of invoices with automated reminders",
		"Social Security Number": "Social Security Number",
		"Something went wrong": "Something went wrong",
		"Specific Date": "Specific Date",
		"Something went wrong trying to Authenticate":
			"Something went wrong trying to Authenticate",
		"Something went wrong trying to change password":
			"Something went wrong trying to change password",
		"Something went wrong trying to Signup": "Something went wrong trying to Signup",
		"Something went wrong with the authentication system":
			"Something went wrong with the authentication system",
		"Sort by": "Sort by",
		"Specific Rank": "Specific Rank",
		"Specify the reason": "Specify the reason",
		Staff: "Staff",
		Staffed: "Staffed",
		"Staff member deleted": "Staff member deleted",
		"Staff Admin": "Staff Admin",
		"Staff Members": "Staff Members",
		"Staff member successfully deleted": "Staff member successfully deleted",
		"Staggered Assignment": "Staggered Assignment",
		"Staggered Posting": "Staggered Posting",
		"Staggered Rule Name": "Staggered Rule Name",
		"Staggered rule created successfully": "Staggered rule created successfully",
		"Staggered rule updated successfully": "Staggered rule updated successfully",
		"Staggered Rule deleted successfully": "Staggered Rule deleted successfully",
		Standard: "Standard",
		Start: "Start",
		"Start Date": "Start Date",
		"Start Date & Time": "Start Date & Time",
		"Start Period": "Start Period",
		"Start Time": "Start Time",
		"Starting soon": "Starting soon",
		Starts: "Starts",
		State: "State",
		"State of Emergency": "State of Emergency",
		Statewide: "Statewide",
		Status: "Status",
		"Status history": "Status History",
		"Street Address": "Street Address",
		"Stripe Subscriptions": "Stripe Subscriptions",
		"Stripe ID / Type": "Stripe ID / Type",
		Subject: "Subject",
		Submit: "Submit",
		Submitted: "Submitted",
		"Submitted By": "Submitted By",
		Subscriptions: "Subscriptions",
		Subtotal: "Subtotal",
		Success: "Success",
		"Summarize job in one sentence": "Summarize job in one sentence",
		Sunday: "Sunday",
		"Sunday to Saturday": "Sunday to Saturday",
		Supervisor: "Supervisor",
		"Supervisor Approvals": "Supervisor Approvals",
		"Supervisor Management": "Supervisor Management",
		"Supervisor Email": "Supervisor Email",
		"Supervisor Name": "Supervisor Name",
		"Supervisor Phone Number": "Supervisor Phone Number",
		"Suspension End Date": "Suspension End Date",
		"Suspension Reason": "Suspension Reason",
		"Suspension will result in the officer being unsassigned from all upcoming jobs in the set time frame":
			"Suspension will result in the officer being unsassigned from all upcoming jobs in the set time frame",
		"Sync Officers": "Sync Officers",
		"Sync Staff": "Sync Staff",
		"Select Date Range": "Select Date Range",
		"Submitted Timecard": "Submitted Timecard",
		"TCOLE Verification": "TCOLE Verification",
		"Tag name cannot be empty": "Tag name cannot be empty",
		Tags: "Tags",
		Task: "Task",
		Tasks: "Tasks",
		Tax: "Tax",
		"Tax Exemption": "Tax Exemption",
		"Tax Exemption Requests": "Tax Exemption Requests",
		"Tax exemption succesfully updated": "Tax exemption succesfully updated",
		Taxes: "Taxes",
		"Taxes will be determined based on location once a job invoice or estimate has been generated":
			"Taxes will be determined based on location once a job invoice or estimate has been generated",
		TBD: "TBD",
		"Terms of Service": "Terms of Service",
		"Test Message": "Test Message",
		Text: "Text",
		"Thank you for using": "Thank you for using",
		"Thank you for your interest in utilizing RollKall to assist you with the coordination of your extra duty jobs_":
			"Thank you for your interest in utilizing RollKall to assist you with the coordination of your extra duty jobs.",
		"Thank you for your submission_": "Thank you for your submission.",
		"The ability to exclude officer pay on the invoice is only available for Agency Invoicing_":
			"The ability to exclude officer pay on the invoice is only available for Agency Invoicing.",
		"The Client has cancelled the job": "The Client has cancelled the job",
		"The client WILL be paying for this job": "The client WILL be paying for this job",
		"The client WILL be billed electronically through the RollKall platform":
			"The client WILL be billed electronically through the RollKall platform",
		"The client WILL NOT be billed electronically through the RollKall platform":
			"The client WILL NOT be billed electronically through the RollKall platform",
		"The client WILL NOT be paying for this job": "The client WILL NOT be paying for this job",
		"The client is authorized to use department vehicles":
			"The client is authorized to use department vehicles",
		"The contact’s phone number must be 10 digits":
			"The contact’s phone number must be 10 digits",
		"The Department has been created, but it still needs to be approved by an administrator":
			"The Department has been created, but it still needs to be approved by an administrator",
		"The Department has cancelled the job": "The Department has cancelled the job",
		"The amount of time in advance an officer can call-off for a job":
			"The amount of time in advance an officer can call-off for a job",
		"The client has been invited to join RKPay": "The client has been invited to join RKPay",
		"The current job is already active or ended": "The current job is already active or ended",
		"The first officer to apply for the job will be accepted_":
			"The first officer to apply for the job will be accepted.",
		"The following items do not have timecard entries":
			"The following items do not have timecard entries",
		"The following jobs are already associated with an estimate_":
			"The following jobs are already associated with an estimate:",
		"The following jobs are already associated with an invoice_":
			"The following jobs are already associated with an invoice:",
		"The following jobs have changed_": "The following jobs have changed:",
		"The full amount of the invoice will be paid to the agency instead of being distributed to the police officers_":
			"The full amount of the invoice will be paid to the agency instead of being distributed to the police officers.",
		"The grace period has to be longer than the call off time limit_":
			"The grace period has to be longer than the call off time limit.",
		"The invoice could not be paid": "The invoice could not be paid",
		"The invoice could not be recalculated": "The invoice could not be recalculated",
		"The invoice could not be voided": "The invoice could not be voided",
		"The invoice download failed": "The invoice download failed",
		"The invoice has already been voided": "The invoice has already been voided",
		"The invoice is already paid": "The invoice is already paid",
		"The invoices payment has failed": "The invoices payment has failed",
		"The job becomes available to be re-assigned to a new officer_":
			"The job becomes available to be re-assigned to a new officer.",
		"The job will be posted immediately, and officers will be notified of an open job_":
			"The job will be posted immediately, and officers will be notified of an open job.",
		"The job will post on a specific day at a specific time that you have chosen_":
			"The job will post on a specific day at a specific time that you have chosen.",
		"The notification could not be sent": "The notification could not be sent",
		"The notification has been sent": "The notification has been sent",
		"The number of hours officers are limited to work per day cannot be less than 1_":
			"The number of hours officers are limited to work per day cannot be less than 1.",
		"The number of hours officers are limited to work per week cannot be less than 1_":
			"The number of hours officers are limited to work per week cannot be less than 1.",
		"The number of hours officers are limited to work per month cannot be less than 1_":
			"The number of hours officers are limited to work per month cannot be less than 1.",
		"The number of hours officers are limited to work per date range cannot be less than 1_":
			"The number of hours officers are limited to work per date range cannot be less than 1.",
		"The number of recurring days cannot be less than 1_":
			"The number of recurring days cannot be less than 1.",
		"The new invoicing rule date range overlaps with an existing one":
			"The new invoicing rule’s date range overlaps with an existing one",
		"The officer could not be verified": "The officer could not be verified",
		"The officer has been notified_": "The officer has been notified.",
		"The officer has been re-verified": "The officer has been re-verified",
		"The officer will be required to call a coordinator in order to call off_":
			"The officer will be required to call a coordinator in order to call off.",
		"The officer will be required to call you in order to call off_":
			"The officer will be required to call you in order to call off.",
		"The officer will be suspended from RollKall temporarily after a certain number of call offs_":
			"The officer will be suspended from RollKall temporarily after a certain number of call offs",
		"The officer will only see and apply to jobs created by your agency":
			"The officer will only see and apply to jobs created by your agency",
		"The officer will only see jobs on allowed locations":
			"The officer will only see jobs on allowed locations",
		"The officer will see all jobs": "The officer will see all jobs",
		"The officer will see this reason": "The officer will see this reason",
		"The phone number must be 10 digits long_": "The phone number must be 10 digits long.",
		"The safety of our officers and our clients is the most important thing we do":
			"The safety of our officers and our clients is the most important thing we do, ",
		"The selected jobs have already been filled_":
			"The selected jobs have already been filled.",
		"The specified address was not found, please double check":
			"The specified address was not found, please double check",
		"The specified user was not found": "The specified user was not found",
		"The staff member will receive an email to complete the reset process_":
			"The staff member will receive an email to complete the reset process.",
		"The start date should be a valid date_": "The start date should be a valid date.",
		"The supervisor’s phone number must be 10 digits":
			"The supervisor’s phone number must be 10 digits",
		"The date range provided overlaps with an existing one":
			"The date range provided overlaps with an existing one",
		"Then limit": "Then limit",
		"There are no payment methods associated with this account":
			"There are no payment methods associated with this account",
		"There are officers assigned to jobs at this location_":
			"There are officers assigned to jobs at this location.",
		"There is already a coordination fee for the current job":
			"There is already a coordination fee for the current job",
		"There is nothing to display_": "There is nothing to display.",
		"There are unsaved changes on this estimate. Would you like to save these before applying job updates?": "There are unsaved changes on this estimate. Would you like to save these before applying job updates?",
		"This client is currently not authorized to use department vehicles_ Please review any positions that may be affected_":
			"This client is currently not authorized to use department vehicles. Please review any positions that may be affected.",
		"This client has opted in to having all invoices include Officer Pay":
			"This client has opted in to having all invoices include Officer Pay.",
		"This Officer has Upcoming Jobs scheduled": "This Officer has Upcoming Jobs scheduled",
		"This action cannot be undone_": "This action cannot be undone.",
		"This client is not authorized to use department vehicles, please contact your admin if this is incorrect":
			"This client is not authorized to use department vehicles, please contact your admin if this is incorrect",
		"This event contains flexible shifts": "This event contains flexible shifts",
		"This estimate was overpaid; a refund can be processed if there are available funds after associated invoice(s) are paid ":
			"This estimate was overpaid; a refund can be processed if there are available funds after associated invoice(s) are paid",
		"This information will be shown to clients so they understand payment conditions":
			"This information will be shown to clients so they understand payment conditions",
		"This is a test message from RollKall": "This is a test message from RollKall",
		"This is the object identifier in Azure Active Directory B2C. This can be useful for looking up users in the directory":
			"This is the object identifier in Azure Active Directory B2C. This can be useful for looking up users in the directory",
		"This job cannot be selected since it is not managed by your agency":
			"This job cannot be selected since it is not managed by your agency",
		"This is viewable and used by officers to understand payment terms that are not RKPay":
			"This is viewable and used by officers to understand payment terms that are not RKPay",
		"This job has been prepaid, no overtime hours are allowed_":
			"This job has been prepaid, no overtime hours are allowed.",
		"This job is part of a recurring series_": "This job is part of a recurring series.",
		"This officer cannot be assigned to current job due to a conflict with an external schedule_":
			"This officer cannot be assigned to current job due to a conflict with an external schedule.",
		"This officer does not qualify to be assigned to jobs on these dates":
			"This officer does not qualify to be assigned to jobs on these dates",
		"This officer is already assigned to another jobs on these dates":
			"This officer is already assigned to another jobs on these dates",
		"This officer is assigned to multiple occurrences of this job":
			"This officer is assigned to multiple occurrences of this job",
		"This personnel is assigned to an on-duty job that overlaps with this assignment_":
			"This personnel is assigned to an on-duty job that overlaps with this assignment.",
		"This external personnel is assigned to an on duty job at this time and cannot be assigned to this position_":
			"This external personnel is assigned to an on duty job at this time and cannot be assigned to this position.",
		"This represents total amount you are expected to receive_":
			"This represents total amount you are expected to receive.",
		"This user is not allowed to use this portal":
			"This user is not allowed to use this portal",
		"This will allow the officer to be removed from the job only if a replacement is found within the specified Call Off Range_":
			"This will allow the officer to be removed from the job only if a replacement is found within the specified Call Off Range.",
		"This will allow an officer to be able to remove themselves completely from a job_":
			"This will allow an officer to be able to remove themselves completely from a job.",
		"This will allow an officer to be able to remove themselves completely from a job with no additional actions required_":
			"This will allow an officer to be able to remove themselves completely from a job with no additional actions required.",
		"This will allow the officer to be removed from the job only if a replacement is found_":
			"This will allow the officer to be removed from the job only if a replacement is found.",
		"This will help expedite payment to everyone_":
			"This will help expedite payment to everyone.",
		"This will make the job visible to all officers on RollKall who meet the requirements of the job_":
			"This will make the job visible to all officers on RollKall who meet the requirements of the job.",
		"This zone is used by some locations. Are you sure you want to delete this zone_":
			"This zone is used by some locations. Are you sure you want to delete this zone?",
		Thursday: "Thursday",
		"Thursday to Wednesday": "Thursday to Wednesday",
		Time: "Time",
		Timecard: "Timecard",
		"Timecard Notes": "Timecard Notes",
		"Time to Consider": "Time to Consider",
		"Time to Post": "Time to Post",
		"Timecard Attachments": "Timecard Attachments",
		"Timecard Exception": "Timecard Exception",
		"Timecard Clockin": "Timecard Clockin",
		"Timecard Clockout": "Timecard Clockout",
		"Timecard Hours": "Timecard Hours",
		"Timecard Note": "Timecard Note",
		"Timecard notes placeholder": "Please leave timecard notes here",
		"Timecard Details": "Timecard Details",
		"Time Zone": "Time Zone",
		Title: "Title",
		To: "To",
		"To convert this estimate, please select a due date for the invoice_":
			"To convert this estimate, please select a due date for the invoice.",
		Today: "Today",
		"To enable Officer Invoicing, you must remove paycodes from all positions":
			"To enable Officer Invoicing, you must remove paycodes from all positions",
		"to Monday": "to Monday",
		ToolbarDisabledAction: "This action is not available for this item in its current state",
		"to Tuesday": "to Tuesday",
		"to Wednesday": "to Wednesday",
		"to Thursday": "to Thursday",
		"to Friday": "to Friday",
		"to Saturday": "to Saturday",
		"to Sunday": "to Sunday",
		"generateEstimateInvoiceModalBody_first":
			"To generate this invoice you will need to add a due date and confirm.",
		"generateEstimateInvoiceModalBody_second":
			"This can later be changed in the invoice if needed.",
		"Token Info": "Token Info",
		Total: "Total",
		"Total Balance": "Total Balance",
		"Total Coordination Fees": "Total Coordination Fees",
		"Total Due": "Total Due",
		"Total Earnings": "Total Earnings",
		"Total Estimate": "Total Estimate",
		"Total Fees Invoiced": "Total Fees Invoiced",
		"Total Fees Paid": "Total Fees Paid",
		"Total Hours": "Total Hours",
		"Total Hours Scheduled": "Total Hours Scheduled",
		"Total Hours Worked": "Total Worked Hours",
		"Total Invoice": "Total Invoice",
		"Total Invoiced": "Total Invoiced",
		"Total Invoiced Amount": "Total Invoiced Amount",
		"Total Jobs": "Total Jobs",
		"Total Jurisdiction Fees": "Total Jurisdiction Fees",
		"Total Locations": "Total Locations",
		"Total Officer Pay": "Total Officer Pay",
		"Total Officers": "Total Officers",
		"Total Paid": "Total Paid",
		"Total Project Count": "Total Project Count",
		"Total affected jobs": "Total affected jobs",
		"Total Refunded Amount": "Total Refunded Amount",
		Transaction: "Transaction",
		"Transaction ID": "Transaction ID",
		"Transfer coordination fees to agency": "Transfer coordination fees to agency",
		"Transfer officer payments to agency": "Transfer officer payments to agency",
		"Transfer Payments to Agency": "Transfer Payments to Agency",
		"Transfer payments to officer": "Transfer payments to officer",
		"Transfer payments to agency for this client_s jobs":
			"Transfer payments to agency for this client's jobs",
		Tuesday: "Tuesday",
		"Tuesday to Monday": "Tuesday to Monday",
		Type: "Type",
		"Type and hit search to filter": "Type and hit search to filter",
		"Type jurisdiction name": "Type jurisdiction name",
		"Type of fee": "Type of fee",
		"Unable to add attachment": "Unable to add attachment",
		"Unable to archive this invoice": "Unable to archive this invoice",
		"Unable to create rule The new rule has the same criteria as an existing one":
			"Unable to create rule. The new rule has the same criteria as an existing one",
		"Unable to unarchive this invoice": "Unable to unarchive this invoice",
		"Unable to delete attachment": "Unable to delete attachment",
		"Unable to delete row": "Unable to delete row",
		"Unable to delete job draft": "Unable to delete job draft",
		"Unable to delete, since there are jobs associated with this location":
			"Unable to delete, since there are jobs associated with this location",
		"Unable to get account information": "Unable to get account information",
		"Unable to load activities": "Unable to load activities",
		"Unable to load client locations": "Unable to load client locations",
		"Unable to load file": "Unable to load file",
		"Unable to load invoice disputes": "Unable to load invoice disputes",
		"Unable to merge contact": "Unable to merge contact",
		"Unable to migrate group": "Unable to migrate group",
		"Unable to retrieve clients": "Unable to retrieve clients",
		"Unable to retrieve client fees": "Unable to retrieve client fees",
		"Unable to retrieve client active fees": "Unable to retrieve client active fees",
		"Unable to retrieve organization users": "Unable to retrieve organization users",
		"Unable to retrieve timecard attachments": "Unable to retrieve timecard attachments",
		"Unable to retrieve timecard notes_": "Unable to retrieve timecard notes.",
		"Unable to update client rates": "Unable to update client rates",
		"Unable to update client fees": "Unable to update client fees",
		"Unable to set primary contact": "Unable to set primary contact",
		"Unable to validate address": "Unable to validate address",
		"Unable to update rule An existing rule for the same date range has the same criteria":
			"Unable to update rule. An existing rule for the same date range has the same criteria.",
		Unapply: "Unapply",
		"Unapply Payment": "Unapply Payment",
		Unarchive: "Unarchive",
		Unarchived: "Unarchived",
		Unassign: "Unassign",
		"Unassign Officer from Jobs": "Unassign Officer from Jobs",
		"Unassign this officer to the following days of the week in this series":
			"Unassign this officer to the following days of the week in this series",
		Unassigned: "Unassigned",
		"Unassignment Reason Details": "Unassignment Reason Details",
		Unanswered: "Unanswered",
		Understaffed: "Under-Staffed",
		"Unique Officers": "Unique Officers",
		Unpaid: "Unpaid",
		"Unpaid Estimate Balance": "Unpaid Estimate Balance",
		Unpost: "Unpost",
		"Unposted Jobs": "Unposted Jobs",
		Unspecified: "Unspecified",
		Unstaffed: "Unstaffed",
		"Unstaffed Jobs": "Unstaffed Jobs",
		"Unsynced officers": "Unsynced officers",
		Until: "Until",
		"Un-Finalize Invoice": "Un-Finalize Invoice",
		"Unknown": "Unknown",
		Upcoming: "Upcoming",
		"Upcoming Jobs": "Upcoming Jobs",
		Update: "Update",
		"Update Agency Name and Logo": "Update Agency Name and Logo",
		"Update an existing invoice": "Update an existing invoice",
		"Update Estimate": "Update Estimate",
		"Update Groups": "Update Groups",
		"Update Image": "Upload Image",
		"Update Invoice": "Update Invoice",
		"Update Shift": "Update Shift",
		"Update name, address and timezone": "Update name, address and timezone",
		Updated: "Updated",
		"Updated successfully": "Updated successfully",
		"Updated Organization Deposit Account successfully":
			"Updated Organization Deposit Account successfully",
		Updating: "Updating",
		Upload: "Upload",
		"Upload Department Rules": "Upload Department Rules",
		"Upload Successful": "Upload Successful",
		"Upload Tax Exempt Documentation": "Upload Tax Exempt Documentation",
		"Upload Verification Document": "Upload Verification Document",
		"Uploaded Files": "Uploaded Files",
		"Upload Document": "Upload Document",
		"Use **Text** for bold": "Use **Text** for bold: ",
		"Use [RollKall dot com] for links": "Use [RollKall](http://rollkall.com) for links:",
		"Use _Text_ for emphasis": "Use _Text_ for emphasis: ",
		"Use a single posting rule": "Use a single posting rule",
		"Use military time": "Use Military Time",
		"Use on-duty schedule to prevent overlapping shifts":
			"Use on-duty schedule to prevent overlapping shifts",
		"Use this location": "Use this location",
		"Use staggered posting": "Use staggered posting",
		User: "User",
		User_: "User:",
		"User could not be synced": "User could not be synced",
		"User Details": "User Details",
		"User needs to add a late fee": "User needs to add a late fee",
		"User ID": "User ID",
		"User Information": "User Information",
		"User Type": "User Type",
		"User successfully updated": "User successfully updated",
		"User Schedule Integration": "User Schedule Integration",
		"Personnel Schedule Conflict": "Personnel Schedule Conflict",
		Username: "Username",
		Users: "Users",
		"Users migrated": "Users migrated",
		Value: "Value",
		Vehicle: "Vehicle",
		Vehicles: "Vehicles",
		"Vehicle fees": "Vehicle fees",
		"Vehicle Fees": "Vehicle Fees",
		"Vehicle fees cannot be duplicated": "Vehicle fees cannot be duplicated",
		"Vehicle Management": "Vehicle Management",
		"Vehicle Number": "Vehicle Number",
		"Vehicle type not selected for a vehicle fee":
			"Vehicle type not selected for a vehicle fee",
		"Vehicle Type": "Vehicle Type",
		"Vehicle Types": "Vehicle Types",
		"Vehicle created successfully": "Vehicle created successfully",
		"Vehicle deleted successfully": "Vehicle deleted successfully",
		"Vehicle updated successfully": "Vehicle updated successfully",
		"Invoicing Required with Vehicles": "Invoicing Required with Vehicles",
		"Vehicle Invoicing Required": "Vehicle Invoicing Required",
		"Vehicle Invoicing Required Modal Message":
			"Your department has required vehicle invoicing when a vehicle is added to a job, please select either Officer or Agency Invoicing.",
		"Vehicle _": "Vehicle #",
		"Vendor Policies": "Vendor Policies",
		Verified: "Verified",
		Verification: "Verification",
		"Verification Checklist": "Verification Checklist",
		"Verification Form": "Verification Form",
		"Verification History": "Verification History",
		"Verification Status": "Verification Status",
		Verify: "Verify",
		"Verify Bank Account": "Verify Bank Account",
		"Verify Officer": "Verify Officer",
		Verifying: "Verifying",
		"Vetted By": "Vetted By",
		"Vetted Comments": "Vetted Comments",
		"Vetted Date": "Vetted Date",
		"Vetted Status": "Vetted Status",
		View: "View",
		"View Activity": "View Activity",
		"View All": "View All",
		"View Billing History": "View Billing History",
		"View Coordinator Jobs": "View Coordinator Jobs",
		"View Details": "View Details",
		"View Dispute": "View Dispute",
		"View File": "View File",
		"View History": "View History",
		"View In Map": "View In Map",
		"View Job": "View Job",
		"View Job History": "View Job History",
		"View Jobs": "View Jobs",
		"View Locations": "View Locations",
		"View PDF": "View PDF",
		"View Receipt": "View Receipt",
		"View Report": "View Report",
		"View Roster": "View Roster",
		"View Payments": "View Payments",
		"Viewing group (audience)": "Viewing group (audience)",
		Visibility: "Visibility",
		"Vehicle Invoicing: Officer Pay Opt-Out": "Vehicle Invoicing: Officer Pay Opt-Out",
		"Vehicle Required": "Vehicle Required",
		Void: "Void",
		Voided: "Voided",
		"Void & Refund Estimate": "Void & Refund Estimate",
		"Voiding this estimate will also trigger a refund for the amount below":
			"Voiding this estimate will also trigger a refund for the amount below",
		"Waive Jurisdiction Fees": "Waive Jurisdiction Fees",
		Warning: "Warning",
		Wednesday: "Wednesday",
		"Wednesday to Tuesday": "Wednesday to Tuesday",
		"We have successfully processed your payment_":
			"We have successfully processed your payment.",
		"We will get you setup in a few steps": "We will get you setup in a few steps",
		Week: "Week",
		"Weekend Multiplier": "Weekend Multiplier",
		Weekly: "Weekly",
		"Weekly:": "Weekly:",
		"Weekly Total": "Weekly Total",
		"What kind of job is this_": "What kind of job is this?",
		"What type of invoicing do you want to use_": "What type of invoicing do you want to use?",
		"What type of job is this_": "What type of job is this?",
		"What_s New": "What's New",
		"When selected, this will prevent coordinators from reassigning officers from other coordinator's jobs.":
			"When selected, this will prevent coordinators from reassigning officers from other coordinator's jobs.",
		"When to post": "When to post",
		"When would you like to assign officers for the job_":
			"When would you like to assign officers for the job?",
		"which will then be automatically assigned to the officer with the fewest number of hours_":
			"which will then be automatically assigned to the officer with the fewest number of hours.",
		"Which instance of this job would you like to delete_":
			"Which instance of this job would you like to delete?",
		"Which instance would you like to restore_": "Which instance would you like to restore?",
		"Who sends the invoice for this job to the client_":
			"Who sends the invoice for this job to the client?",
		"Who will create the invoice_": "Who will create the invoice?",
		"Why are you un-assigning": "Why are you un-assigning",
		"Why are you not invoicing online through the RollKall platform_":
			"Why are you not invoicing online through the RollKall platform?",
		"Will be posted on": "Will be posted on",
		"Will be posted to All Officer Groups on": "Will be posted to All Officer Groups on",
		"Will the client be paying online through the Rollkall platform_":
			"Will the client be paying online through the Rollkall platform?",
		With: "With",
		"With Sign Up Period": "With Sign Up Period",
		Worked: "Worked",
		"Worked Hours": "Worked Hours",
		"Workers comp": "Workers comp",
		"Workers Comp": "Worker’s Comp",
		"Would you like to enforce officer penalties?_":
			"Would you like to enforce officer penalties?",
		"Would you like to allow a call off grace period_":
			"Would you like to allow a call off grace period?",
		"Would you like to finalize before downloading_":
			"Would you like to finalize before downloading?",
		"Would you like to finalize before sending_": "Would you like to finalize before sending?",
		"Would you like to finalize before sending to":
			"Would you like to finalize before sending to",
		"Would you like to finalize before printing_":
			"Would you like to finalize before printing?",
		"Would you like to override this_": "Would you like to override this?",
		"Would you like to post this job to a specific group of officers_":
			"Would you like to post this job to a specific group of officers?",
		"Would you like to proceed with another notification_":
			"Would you like to proceed with another notification?",
		"Would you like to proceed with this assignment_":
			"Would you like to proceed with this assignment?",
		"Would you like to save before applying payment_":
			"Would you like to save before applying payment?",
		"Would you like to save before downloading_": "Would you like to save before downloading?",
		"Would you like to save before leaving this invoice_":
			"Would you like to save before leaving this invoice?",
		"Would you like to save before printing_": "Would you like to save before printing?",
		"Year to Date": "Year to Date",
		"Year to date": "Year to date",
		"Years Of Service": "Years Of Service",
		"Years with current department": "Years with current department",
		Yes: "Yes",
		"Yes, exclude officer pay from the invoice": "Yes, exclude officer pay from the invoice",
		"Yes, Delete": "Yes, Delete",
		"Yes, delete job": "Yes, delete job",
		"Yes, delete jobs": "Yes, delete jobs",
		"Yes, issue refund": "Yes, issue refund",
		"Yes, Proceed": "Yes, Proceed",
		"Yes, refund amount": "Yes, refund amount",
		"Yes, Send Notification": "Yes, Send Notification",
		"Yes, transfer payments to the agency": "Yes, transfer payments to the agency",
		"Yes, transfer payments to the officer": "Yes, transfer payments to the officer",
		"You are about to issue an RKInsurance refund in the amount of_":
			"You are about to issue an RKInsurance refund in the amount of",
		"You are about to post your job, you have": "You are about to post your job, you have",
		"You are about to send an estimate": "You are about to send an estimate",
		"You are all set!": "You are all set!",
		"You are also currently in our queue to verify your information_":
			"You are also currently in our queue to verify your information.",
		"You are currently in our queue to verify your information_":
			"You are currently in our queue to verify your information.",
		"You are not allowed on": "You are not allowed on",
		"You can close this window or wait until the payment finishes_":
			"You can close this window or wait until the payment finishes.",
		"You can override by setting rates per location_":
			"You can override by setting rates per location.",
		"You have": "You have",
		"You have made": "You have made",
		"You have not connected with any clients yet_":
			"You have not connected with any clients yet.",
		"You have not specified any excluded agencies":
			"You have not specified any excluded agencies",
		"You have not specified any required agencies":
			"You have not specified any required agencies",
		"You have not specified any restricted locations":
			"You have not specified any restricted locations",
		"You have selected to dispute invoice": "You have selected to dispute invoice",
		"You have unsaved changes_": "You have unsaved changes.",
		"You have updated the recurrence information_":
			"You have updated the recurrence information.",
		"You have unsaved changes_ Leaving this page will discard them_ Are you sure you want to leave_":
			"You have unsaved changes. Leaving this page will discard them. Are you sure you want to leave?",
		"You must agree to terms of service": "You must agree to terms of service",
		"You need to fill at least one field": "You need to fill at least one field",
		"You need to select a jurisdiction": "You need to select a jurisdiction",
		"You pay all officers directly by yourself_": "You pay all officers directly by yourself.",
		"You will be notified via email when the process is complete_":
			"You will be notified via email when the process is complete.",
		"You will receive an email when your account has been verified and activated within the next 2-3 business days_":
			"You will receive an email when your account has been verified and activated within the next 2-3 business days.",
		"You will then have to manually select the officer you wish to assign to the job_":
			"You will then have to manually select the officer you wish to assign to the job.",
		Your: "Your",
		"Your Fees": "Your Fees",
		"Your Invoice": "Your Invoice",
		"Your LEA account is now setup": "Your LEA account is now setup",
		"Your Receipt": "Your Receipt",
		"Your clients are listed here_": "Your clients are listed here.",
		"Your coordinator account is now set up": "Your coordinator account is now set up",
		"Your job is over 12 hours, are you sure you want to do that_":
			"Your job is over 12 hours, are you sure you want to do that?",
		"Your local timezone is different than your account timezone":
			"Your local timezone is different than your account timezone",
		"Your payment is being processed": "Your payment is being processed",
		"Yes, save a vehicle to this job": "Yes, save a vehicle to this job",
		"You have unsaved changes on this estimate, would you like to save and proceed before sending?":
			"You have unsaved changes on this estimate, would you like to save and proceed before sending?",
		"You have unsaved changes and invoices cannot be changed once they are sent to the client, would you like to save and proceed_":
			"You have unsaved changes and invoices cannot be changed once they are sent to the client, would you like to save and proceed?",
		"You have unsaved changes and invoices cannot be changed once they are sent to the client, would you like to save and proceed?":
			"You have unsaved changes and invoices cannot be changed once they are sent to the client, would you like to save and proceed?",
		"You are sending invoices with different versions":
			"You are sending invoices with different versions.",
		Zip: "Zip",
		"Zip Code": "Zip Code",
		"Zone Name": "Zone Name",
		Zone: "Zone",
		"added a Note": "added a Note",
		"advanced fields": "advanced fields",
		"all of next month jobs_": "all of next month jobs.",
		"be posted": "be posted",
		"changed invoice status to": "changed invoice status to",
		"day of month at": "day of month at",
		"days prior to the job start_": "days prior to the job start.",
		"ending in": "ending in",
		"expires soon": "expires soon",
		"File exceeds the maximum acceptable size": "File exceeds the maximum acceptable size",
		Finalize: "Finalize",
		Finalized: "Finalized",
		"Finalize Invoice": "Finalize Invoice",
		"Finalize and Download": "Finalize and Download",
		"Finalize and Print": "Finalize and Print",
		"Finalize and Send": "Finalize and Send",
		"filed a dispute for invoice": "filed a dispute for invoice",
		"is required for this position": "is required for this position",
		"job(s) for": "job(s) for",
		"job(s) for the next": "job(s) for the next",
		"jobs per officer per round_": "jobs per officer per round.",
		"per officer per round": "per officer per round",
		"jpeg, jpg, png, tif, tiff": ".jpeg, .jpg, .png, .tif, .tiff",
		"local time": "local time",
		"per hour": "per hour",
		Permissions: "Permissions",
		"please keep an eye on your email for further updates_":
			"please keep an eye on your email for further updates.",
		"position details and instructions": "position details and instructions",
		"post to all officer groups": "post to all officer groups",
		"post to specific group of officers": "post to specific group of officers",
		"Repost the job to all eligible officers": "Repost the job to all eligible officers",
		"required for this position": "required for this position",
		"restriction expired": "restriction expired",
		"Seeking Replacement": "Seeking Replacement",
		"seeking replacements": "seeking replacements",
		"Service fee updated successfully": "Service fee updated successfully",
		"so please understand that all submissions are subject to background checks and approval by RollKall_":
			"so please understand that all submissions are subject to background checks and approval by RollKall.",
		"successfully updated": "sucessfully updated",
		"the job will open to all officers if it hasn_t been claimed yet_":
			"the job will open to all officers if it hasn't been claimed yet.",
		"these jobs": "these jobs",
		"this job": "this job",
		"unassigned positions_": "unassigned positions.",
		"Value must be earlier": "Select a value at least 15 minutes before job starts",
		"Date must be earlier": "Select a value at least equal to the job start day",
		"Value must be after": "You cannot select values in the past",
		"View Only": "View Only",
		Enable: "Enable",
		Disable: "Disable",
		"Error getting Authentication Settings": "Error getting Authentication Settings",
		"Authentication Menu Title": "Authentication",
		"Authentication Menu Subtitle": "Set up how personnel authenticate to the system",
		"Authentication Section 2FA Option":
			"Personnel will be required to use 2FA (SMS) when logging in",
		"Authentication Section 2FA Option Tooltip":
			"When 2FA is enabled, personnel will be required to set up a phone number to receive a code via SMS when logging in. This feature can only be turned on by RollKall",
		"Authentication Section Federation Option Disabled":
			"Personnel can authenticate using your agency identity provider",
		"Authentication Section Federation Option Disabled Tooltip":
			"Personnel can authenticate using your agency identity provider. This feature can only be turned on by RollKall",
		"Authentication Section Federation Option":
			"Use federated authentication for personnel accounts",
		"Authentication Section Federation Option Not Enforced":
			"Personnel can use any email address",
		"Authentication Section Federation Option Not Enforced Tooltip":
			"When federation is not enforced, personnel will be able to authenticate with any email address including non federated ones like @gmail.com or @yahoo.com",
		"Authentication Section Federation Option Enforced Tooltip":
			"When federation is enfroced, personnel will only be able to authenticate with a federated email address like @youragency.com after the enforcement date",
		"Authentication Section Federation Option Enforced Set Date":
			"Please set an enforcement date",
		"Authentication Section Federation Option Enforced Date Input Text":
			"All personnel will require a federated email address by",
		"Authentication Settings": "Authentication Settings",
		"Verification Settings": "Verification Settings",
		"Verification Settings Tooltip Off":
			"Select this option when RollKall staff is responsible for performing the verification of officers",
		"Verification Settings Tooltip On":
			"Select this option when the LEA is responsible for performing the verification of officers.",
		Federation: "Federation",
		"Federation Tooltip":
			"Federation allow organizations to authenticate using their own identity provider. This feature can only be turned on by the engineering team.",
		"Account Security Title": "Security",
		"Account Security Password Text": "Password",
		"Account Security MFA Text": "Two-Factor Authentication (2FA)",
		"Account Security MFA Tooltip":
			"Two-Factor authentication (2FA) can be used to help protect your account from unauthorized access by requiring you to enter a security code when you sign in.",
		"Adb2c Edit Mfa Message Success": "2FA successfully configured",
		"Adb2c Disable Mfa Message Success": "2FA successfully disabled",
		"Adb2c Change Email Message Success": "Email successfully changed",
		"Enforce 2FA": "Enforce 2FA",
		"Configure Fees": "Configure Fees",
		"Enforce 2FA Tooltip":
			"Enabling this will enforce Two-Factor Authentication as a requirement for all users across your agency.",
		"The system may take a few minutes to complete the deletion":
			"\n\n The system may take a few minutes to complete the deletion",
		"The audit tool requires all three filters above to be selected to start the audit_":
			"The audit tool requires all three filters above to be selected to start the audit.",
		"Error loading Instant Pay reasons, Please try again_":
			"Error loading Instant Pay reasons, Please try again.",
		"Error getting refunds in transit": "Error getting refunds in transit",
		"Error checking for future officer invoicing jobs": "Error checking for future officer invoicing jobs",
		"Paid Date": "Paid Date",
		"View receipt": "View receipt",
		"Enable Zones for Locations": "Enable Zones for Locations",
		"Personnel are not allowed to work at denied addresses or locations":
			"Personnel are not allowed to work at denied addresses or locations",
		"Job could not be found": "Job could not be found",
		"Personnel are not allowed to work at specific venue types":
			"Personnel are not allowed to work at specific venue types",
		"This location has not been approved by your Agency, please contact an admin for approval":
			"This location has not been approved by your Agency, please contact an admin for approval",
		Processing: "Processing",
		"Ball-Mart": "Ball-Mart",
		"Add to Summary": "Add to Summary",
		"Invoices cannot be changed once they are sent to the client, would you like to proceed?":
			"Invoices cannot be changed once they are sent to the client, would you like to proceed?",
		"Search by invoice number": "Search by invoice number",
		"Need to send to additional people? Add emails below, separated by a comma":
			"Need to send to additional people? Add emails below, separated by a comma",
		BCC: "BCC",
		CC: "CC",
		"Invoice will be sent to all the recipients selected below":
			"Invoice(s) will be sent to all the recipients selected below.",
		"Estimate will be sent to all the recipients selected below":
			"Estimate(s) will be sent to all the recipients selected below.",
		"Add new client contact": "Add new client contact",
		"A client must be selected before creating a contact":
			"A client must be selected before creating a contact",
		"Send an email to myself": "Send an email to myself",
		"Send Reminder": "Send Reminder",
		"A reminder to pay this invoice will be sent to the contacts below":
			"A reminder to pay this invoice will be sent to the contacts below",
		"Error sending reminders": "Error sending reminders",
		"Reminder Sending Complete": "Reminder Sending Complete",
		"The email format you’ve added is incorrect, please add an email with a valid format":
			"The email format you’ve added is incorrect, please add an email with a valid format",
		"Select a billing contact": "Select a billing contact",
		"Invoice Errors": "Invoice Errors",
		"The following invoices selected to send have errors":
			"The following invoices selected to send have errors",
		"To continue with the sending process, fix these invoices individually, after errors are resolved invoices can be successfully sent":
			"To continue with the sending process, fix these invoices individually, after errors are resolved invoices can be successfully sent",
		"Dispute History": "Dispute History",
		"No dispute history to display": "No dispute history to display",
		"Select a dispute to view details": "Select a dispute to view details",
		"Unable to load invoice dispute history": "Unable to load invoice dispute history",
		Acknowledge: "Acknowledge",
		"Create a Job / Estimate": "Create a Job / Estimate",
		"Attach File": "Attach File",
		"Replace File": "Replace File",
		"Include coordinators": "Include coordinators",
		"Unable to load job draft": "Unable to load job draft",
		"Error retrieving jurisdiction restrictions": "Error retrieving jurisdiction restrictions",
		"Please verify that all required info has been entered":
			"Please verify that all required info has been entered",
		"By Name": "By Name",
		"Position Rank": "Position Rank",
		"Position Time": "Position Time",
		"Error loading additional information": "Error loading additional information",
		"Agency Invoice Disputes (beta)": "Agency Invoice Disputes (beta)",
		NexusNetworkError:
			"We could not complete your request. It may have been blocked for security reasons or have been interrupted by a network issue. If it keeps happening, please contact our support team for assistance.",
		dynamic: {
			"Authentication Section Federation Option Enforced":
				"Personnel can only use federated email address with domain %{domain}",
			"A contact with email already exists":
				"A contact with the email %{EmailAddress} already exists :",
			"Are you sure you want to delete": "Are you sure you want to delete %{subject}?",
			"Are you sure you want to delete the position":
				"Are you sure you want to delete the %{positionName} position?",
			"Are you sure you want to delete this":
				"Are you sure you want to delete this %{subject}?",
			"Are you sure you want to reset the users password":
				"Are you sure you want to reset %{user}'s password?",
			"Are you sure you want to restore": "Are you sure you want to restore %{subject}?",
			"Assigning officer to a recurring job":
				"You are assigning officer %{FirstName} %{LastName} to a recurring job. Please tell us if you would like to assign this officer to this single job occurrence or future occurrences.",
			"Assignment managed by": "Assignments for this job are managed by %{agency}",
			"Do you want to delete or migrate those user(s) to another organization":
				"Organization %{organizationId} has %{users} user(s), do you want to delete or migrate those user(s) to another organization?",
			"Do you want to act only this instance, or all upcoming instances of this series":
				"Do you want to %{action} only this instance, or all upcoming instances of this series?",
			EstimateActionsBannerRefund_:
				"A refund for %{refundableAmount} can be performed and the estimate can then be archived.",
			EstimateRefundAndArchiveModalWithAssociatedInvoicesText:
				"This estimate can now be refunded and archived. The refund of $%{refundAmount} will be issued to the original form of payment, and the estimate will automatically be archived after the refund succeeds.",
			EstimateRefundAndArchiveModalWithNoJobsWorkedText:
				"The refund of $%{refundAmount} will be issued to the original form of payment, and the estimate will be automatically archived once the refund is successful. Clients will see refunds in approximately 5-10 business days, depending upon the bank.",
			"Filter by": "Filter by %{property}",
			"Go to": "Go to %{place}",
			"Net number": "Net, %{number}",
			"New Applicant": "%{smart_count} New Applicant |||| %{smart_count} New Applicants",
			"Ninety Day Interval": "%{period} 90 days",
			"Please select at least one job to": "Please select at least one job to %{action}",
			"Posted to group": "Posted to group: %{PostedGroupName} on",
			"Reports to": "Reports to %{title}",
			"Refund NonRKPayInvoiceEstimateModal body dynamic message":
				"This estimate will be voided and a refund of $%{refundAmount} will be issued to you.",
			"Starts in days": "Starts in %{smart_count} day |||| Starts in %{smart_count} days",
			"Starts in hours": "Starts in %{smart_count} hour |||| Starts in %{smart_count} hours",
			"Starts in minutes":
				"Starts in %{smart_count} minute |||| Starts in %{smart_count} minutes",
			"Thirty Day Interval": "%{period} 30 days",
			"Unassigning officer": "Unassigning %{officerName}",
			"Will be posted to group": "Will be posted to group: %{PostedGroupName} on",
			"Yearly interval": "%{period} Year",
			"You have dispute pending response":
				"You have %{disputesCount} dispute(s) pending response",
			"Your bank account will be charged":
				"Your %{bankName} ending in %{accNumber} will be charged.",
			"Your card will be charged": "card %{cardNumber} will be charged.",
			"deleted successfully": "%{item} deleted successfully",
			"miles from job site":
				"%{smart_count} mile from job site |||| %{smart_count} miles from job site",
			navigationEstimateInvoiceModal:
				"An invoice has been generated from Estimate %{estimateNumber}, reflecting the completed jobs. You can now review, edit, and send the invoice to the client. Once the invoice is marked as paid, additional actions, such as issuing a refund or archiving the estimate, will become available.",
			"officer verification status will remain valid until date":
				"By clicking Re-Verify, this officer's verification status will remain valid until %{date}",
			"Please select a user to supervise jobs currently assigned to":
				"Please select a user to supervise jobs currently assigned to %{name}",
			"Update manual invoice items_": "Would you like to apply these updates to the %{type}?",
			"Manual invoice jobs deleted":
				"All jobs associated with this %{type} have been deleted.",
			"Manual invoice no longer valid": "This %{type} may no longer be valid.",
			"expires in days": "expires in %{smart_count} day |||| expires in %{smart_count} days",
			"expires in hours":
				"expires in %{smart_count} hour |||| expires in %{smart_count} hours",
			"expires in minutes":
				"expires in %{smart_count} minute |||| expires in %{smart_count} minutes",
			"This invoice has a prepayment, the current balance is":
				"This invoice has a prepayment, the current balance is %{balance}",
			"Void & Refund Estimate refund amount": "Refund Amount $%{appliedPayments}",
			"An invoice can only be sent back to the client once all disputes reasons have been addressed.":
				"An invoice can only be sent back to the client once all disputes reasons have been addressed.",
			"All disputes are resolved; the invoice is ready to be sent.":
				"All disputes are resolved; the invoice is ready to be sent.",
			"Subsequent edits on the invoice as a whole can be made prior to sending, if applicable.":
				"Subsequent edits on the invoice as a whole can be made prior to sending, if applicable.",
			"Dispute reasons have been addressed":
				"%{completed} of %{total} dispute reasons have been addressed.",
			DisputeReasonGroupSubtitle: "%{completed} of %{total} addressed",
		},
	},
	// Spanish
	es: {},
};

/* Set or restore the language settings */
global.setLanguage = langSetting => {
	let newLangSetting = langSetting;
	if (!langSetting) {
		const currentSetting = localStorage.getItem("lang");
		newLangSetting = currentSetting || "en";
	}
	global.lang = new Polyglot({ locale: newLangSetting });
	global.lang.extend(global.phrases[newLangSetting]);
	localStorage.setItem("lang", newLangSetting);
};
